import axios from 'axios';

const ZWSAPIRoleMap = {
  getBatchAlertEvents: "alert:alert-data-event:query",
  deleteBatchAlertEvents: "alert:alert-data-event:delete",
  getSingleAlertEvents: "alert:alert-data-event:query",
  updateSingleEventsStatus: "alert:alert-data-event:handle",
  deleteAllAlertEvents: "alert:alert-data-event:delete",
  getBatchEdgeComputingRules: "alert:edge-computing-rule:query",
  getSingleEdgeRule: "alert:edge-computing-rule:query",
  addSingleEdgeRule: "alert:edge-computing-rule:create",
  issueSingleEdgeComputingRule: "alert:edge-computing-rule:issuance",
  updateSingleEdgeRule: "alert:edge-computing-rule:update",
  deleteSingleEdgeRule: "alert:edge-computing-rule:delete",
  getBatchEdgeRuleIssuanceHistory: "alert:edge-computing-rule-issuance-history:query",
  deleteEdgeIssuanceHistories: "alert:edge-computing-rule-issuance-history:delete",
  addBatchAlertAction: "alert:rule-action:update",
  addBatchAlertActionRecovery: "alert:rule-action:update",
  updateSingleAlertAction: "alert:rule-action:update",
  updateSingleAlertActionRecovery: "alert:rule-action:update",
  deleteBatchAlertActions: "alert:rule-action:delete",
  deleteBatchAlertActionsRecovery: "alert:rule-action:delete",
  addThingsForwardAction: "alert:things-forward-action:create",
  updateThingsForwardAction: "alert:things-forward-action:update",
  deleteThingsForwardAction: "alert:things-forward-action:delete",
  getBatchThingsForwardRules: "alert:things-forward-rules:query",
  getSingleThingsForwardRule: "alert:things-forward-rules:query",
  getBatchRules: "alert:trigger-rule:query",
  updateRuleStatus: "alert:trigger-rule:update",
  deleteSingleRule: "alert:trigger-rule:delete",
  addSingleAlertRule: "alert:trigger-rule:create",
  updateSingleAlertRule: "alert:trigger-rule:update",
  addSingleDataDashbord: "data-mgmt:dashboard:create",
  updateSingleDataDashbord: "data-mgmt:dashboard:update",
  deleteSingleDataDashbord: "data-mgmt:dashboard:delete",
  getBatchDashbords: "data-mgmt:dashboard:query",
  addSingleDataDashbordPanel: "data-mgmt:dashboard-panel:create",
  deleteSingleDataDashbordPanel: "data-mgmt:dashboard-panel:delete",
  updateSingleDataDashbordPanel: "data-mgmt:dashboard-panel:update",
  getSingleThingsData: "data-mgmt:thing-data:query",
  getSingleThingsDataAggregation: "data-mgmt:thing-data:history-aggregation",
  getBatchGroupDatas: "data-mgmt:thing-data:query",
  issueRequestDownloadDeviceData: "data-mgmt:thing-data:download",
  getQueryDownloadDeviceData: "data-mgmt:thing-data:download",
  getDataDownloadList: "data-mgmt:thing-data:download",
  updateDataDownloadStatus: "data-mgmt:thing-data:download",
  getBindDashbord: "data-mgmt:user-dashboard:query",
  updateBindDashbord: "data-mgmt:user-dashboard:update",
  getBatchJobs: "job-mgmt:job:query",
  addSingleJob: "job-mgmt:job:create",
  updateSingleJob: "job-mgmt:job:edit",
  updateSingleJobStatus: "job-mgmt:job:edit-status",
  getSingleJobDetails: "job-mgmt:job:query",
  deleteSingleJob: "job-mgmt:job:delete",
  getBatchJobLogs: "job-mgmt:job-log:query",
  deleteSingleJobLog: "job-mgmt:job-log:delete",
  deleteBatchJobLogs: "job-mgmt:job-log:delete",
  deleteAllJobLog: "job-mgmt:job-log:delete",
  getDownloadUrl: "firmware:firmware:query",
  getBatchFirmwares: "firmware:firmware:query",
  getPackageInfo: "filemanager:package:query",
  deletePackage: "filemanager:package:delete",
  uploadPackage: "filemanager:package:upload",
  getAllPackages: "filemanager:package:query",
  getLastPackage: "filemanager:package:query",
  addBatchDevicesBindToGroup: "group:device:bind",
  issueGroupDeviceCommand: "group:device:command",
  deleteBatchDevicesOfGroup: "group:device:unbind",
  getBatchGroupList: "group:group:query",
  addSingleGroup: "group:group:create",
  updateSingleGroup: "group:group:update",
  deleteBatchGroups: "group:group:delete",
  getBatchProject: "project:project:query",
  addSingleProject: "project:project:create",
  deleteSingleProjectById: "project:project:delete",
  updateSingleProject: "project:project:update",
  relatedSingleProjectResource: "project:project-resource:update",
  relatedBatchProjectResources: "project:project-resource:update",
  updateProjectResourcesRelation: "project:project-resource:update",
  getSingleProjectResources: "project:project-resource:query",
  getBatchProjectResources: "project:project-resource:query",
  deleteProjectResourcesRelation: "project:project-resource:update",
  addSingleThings: "things:things:create",
  addImportThings: "things:things:import",
  addImportWrapperThings: "things:things:import",
  getOutPutAllThings: "things:things:export",
  getOutPutThings: "things:things:export",
  updateBatchThingsAttr: "things:things:batch-update",
  updateBatchThingsConfiguration: "things:things:batch-update",
  getBatchThings: "things:things:query",
  deleteBatchThings: "things:things:delete",
  updateSingleThings: "things:things:update",
  getSingleUserBindThings: "things:user-things:query",
  updateSingleUserBindThings: "things:user-things:update",
  getBatchRolesList: "control:tenant-role:query",
  addSingleRole: "control:tenant-role:create",
  updateSingleRole: "control:tenant-role:update",
  deleteBatchRoles: "control:tenant-role:delete",
  getSingleRole: "control:tenant-role:query",
  getSingleSubuserMenus: "control:user-menu:query",
  updateSingleUserBindMenus: "control:user-menu:update",
  getBatchSubuserRoles: "control:user-role:query",
  updateSingleBindRoles: "control:user-role:update",
  addSingleSubUser: "tenant:user:create",
  addSingleTenantLabel: "tenant:label:create",
  deleteBatchTenantLabels: "tenant:label:delete",
  modifySingleTenantLabel: "tenant:label:update",
  getUserHmiResourceTree: "out-hmi:user:query",
  getBindHmis: "out-hmi:user:query",
  updateBindHmis: "out-hmi:user:update",
  deleteSingleInfoModel: "mapping:info-model:delete",
  addSingleTenantFunctionBlock: "mapping:info-model:create",
  getSingleFunctionBlockDisplaySchema: "mapping:function-block:update",
  updateSingleFunctionBlockEventProperty: "mapping:function-block:update",
  updateSingleFunctionBlockEvent: "mapping:function-block:update",
  addSingleMappingRuleInfos: "mapping:mapping-rule:create",
  getSingleMappingRuleInfos: "mapping:mapping-rule:query",
  updateSingleMappingRuleInfos: "mapping:mapping-rule:update",
  deleteSingleMappingRuleInfos: "mapping:mapping-rule:delete",
  addInfoModelMappingWithItem: "mapping:info-model-mapping:create",
  updateSingleInfoModelMapping: "mapping:info-model-mapping:create",
  getSingleInfoModelMapping: "mapping:info-model-mapping:query",
  addSingleStatisticsMethod: "data-mgmt:data-statistic-method:create",
  deleteSingleStatisticsMethod: "data-mgmt:data-statistic-method:delete",
  updateSingleStatisticsMethod: "data-mgmt:data-statistic-method:update",
  getSingleStatisticsMethod: "data-mgmt:data-statistic-method:get",
  getBatchTenantStatisticsMethods: "data-mgmt:data-statistic-method:page",
  addSingleStatisticsTimerTask: "data-mgmt:data-statistic-task:create",
  addSingleStatisticsTask: "data-mgmt:data-statistic-task:create",
  deleteSingleStatisticsTask: "data-mgmt:data-statistic-task:delete",
  getBatchTenantStatisticsTasks: "data-mgmt:data-statistic-task:page",
  updateSingleStatisticsTask: "data-mgmt:data-statistic-task:update",
  updateSingleStatisticsTaskStatus: "data-mgmt:data-statistic-task:updateStatus",
  executeSingleStatisticsTask: "data-mgmt:data-statistic-task:execute",
  getTenantBatchStatisticTaskDimensionResult: "data-mgmt:data-statistic-jrnl:page",
  getTenantBatchTaskResult: "data-mgmt:data-statistic-jrnl:page",
  addSingleSingleWorkOrder: "work:work:create",
  getBatchSingleWorkOrders: "work:work:query",
  updateSingleSingleWorkOrder: "work:work:handle",
  deleteSingleSingleWorkOrder: "work:work:delete",
  getSingleSingleWorkOrder: "work:work:query",
  uploadFile: "out-file-manager:file-manager:upload"
};

let errorCodeList;
globalThis.errorCodeList = globalThis.errorCodeList ?? {};
errorCodeList = globalThis.errorCodeList;
let errorCodeListInited = false;
let errorHandler;
let noHandlerError;
let fetchLocale = "zh";
function setFetchLocale(locale) {
  fetchLocale = locale;
}
function handleError(err) {
  var _a, _b, _c;
  let errDataArr = [];
  let errorArr = [];
  if (Array.isArray((_a = err.data) == null ? void 0 : _a.data)) {
    errDataArr = err.data.data;
  } else {
    errDataArr = [err.data];
  }
  errDataArr.forEach((errItem) => {
    var _a2;
    let errorItemCode = (errItem == null ? void 0 : errItem.code) || "http." + err.status;
    let errorItemMsg = (errItem == null ? void 0 : errItem.message) || errorItemCode;
    if (errorItemCode && typeof errorItemCode === "string") {
      let errorModule = errorItemCode.split(".")[0];
      if (errorModule.indexOf("iot-") === -1) {
        errorModule = "iot-" + errorModule;
        errorItemCode = "iot-" + errorItemCode;
      }
      const locale = fetchLocale === "zh" ? "" : `-${fetchLocale}`;
      errorItemMsg = ((_a2 = errorCodeList[`${errorModule}${locale}`]) == null ? void 0 : _a2[errorItemCode]) || errorItemCode;
    }
    errorArr.push({
      errorItemCode,
      errorItemMsg,
      errItem
    });
  });
  const errorCode = (_b = errorArr[0]) == null ? void 0 : _b.errorItemCode;
  const errorMsg = (_c = errorArr[0]) == null ? void 0 : _c.errorItemMsg;
  let output = () => {
    if (errorHandler) {
      errorHandler(errorCode, err, noHandlerError, errorArr);
    }
    return new Promise((resolve, reject) => {
      reject({
        errorCode,
        errorMsg,
        errorArr,
        err
      });
    });
  };
  return output();
}
function setErrorHandler(handler, noHandlerError2) {
  if (typeof handler === "function") {
    errorHandler = handler;
  } else {
    throw new Error("Error Handler Must Be Function");
  }
}
let getStorageCallback;
function setGetStorage(callback) {
  getStorageCallback = callback;
}
function _getStorage(key) {
  if (getStorageCallback)
    return getStorageCallback(key);
  else
    return;
}
let setStorageCallback;
function setSetStorage(callback) {
  setStorageCallback = callback;
}
function _setStorage(key, value) {
  if (setStorageCallback)
    setStorageCallback(key, value);
}
let removeStorageCallback;
function setRemoveStorage(callback) {
  removeStorageCallback = callback;
}
function _removeStorage(key) {
  if (removeStorageCallback)
    removeStorageCallback(key);
}
let _fetchToken;
function setFetchToken(token) {
  _fetchToken = token;
}
function _getFetchToken() {
  if (_fetchToken)
    return _fetchToken;
  return _getStorage("token");
}
function generateHttpHeader() {
  return {
    "Authorization": "Bearer " + _getFetchToken()
  };
}
function generateHttpAuthorization() {
  return "Bearer " + _getFetchToken();
}
function init(baseURL2, timeout2, header) {
}
let baseURL;
function setErrorCodeList(list) {
  if (errorCodeListInited)
    return;
  for (let key in list) {
    if (errorCodeList[key])
      continue;
    errorCodeList[key] = list[key];
  }
  errorCodeListInited = true;
}
function getErrorCodeList(origin) {
  if (window.existsErrorCodeList)
    return;
  let url = "";
  if (window.location.origin.indexOf("file:") >= 0) {
    if (!origin)
      return;
    url = `${origin}/api_error_code/error_code.json`;
  } else if (window.location.host.indexOf("localhost") < 0 && window.location.host.indexOf("127.0.0.1") < 0) {
    if (window.location.host.indexOf(".com") > -1)
      url = `${window.location.protocol}//zws.zlgcloud.com/api_error_code/error_code.json`;
    else
      url = `${window.location.origin}/api_error_code/error_code.json`;
  } else
    url = `${window.location.protocol}//192.168.24.10/api_error_code/error_code.json`;
  if (!window.downloadingErrorCodeList)
    window.downloadingErrorCodeList = true;
  else
    return;
  window.fetch(url).then((response) => response.text()).then((data) => {
    window.downloadingErrorCodeList = false;
    try {
      setErrorCodeList(JSON.parse(data));
      window.existsErrorCodeList = true;
    } catch (err) {
      console.log("\u89E3\u6790API\u9519\u8BEF\u7801\u8868\u5931\u8D25", err);
    }
  }).catch((error) => {
    window.downloadingErrorCodeList = false;
    console.error("\u83B7\u53D6API\u9519\u8BEF\u7801\u8868\u5931\u8D25", error);
  });
}
getErrorCodeList();
function setBaseUrl(baseURLStr) {
  baseURL = baseURLStr;
  getErrorCodeList(new URL(baseURLStr).origin);
}
function getBaseUrl() {
  if (baseURL)
    return baseURL;
  if (window && window.location.host.indexOf("localhost") >= 0)
    return "/api";
  return "/v1";
}
let timeout = 3e4;
function setGlobalTimeout(globalTimeout) {
  timeout = globalTimeout;
}
function getGlobalTimeout() {
  return timeout;
}
let fetchCallback;
function setFetch(callback) {
  if (typeof callback === "function") {
    fetchCallback = callback;
  } else {
    console.error("Fetch \u5FC5\u987B\u4E3A Function");
  }
}
function setRoles(apis) {
  const userApiRoleListMap = {};
  apis == null ? void 0 : apis.forEach((item) => {
    userApiRoleListMap[item.name] = true;
  });
  _setStorage(
    "userApiRoleListMap",
    JSON.stringify(userApiRoleListMap)
  );
}
function removeRoles() {
  _removeStorage("userApiRoleListMap");
}
function hasPermission(apiRoleNames) {
  const userApiRoleListMap = _getStorage("userApiRoleListMap") ? JSON.parse(_getStorage("userApiRoleListMap")) : void 0;
  if (userApiRoleListMap) {
    if (typeof apiRoleNames === "string") {
      return userApiRoleListMap.hasOwnProperty(apiRoleNames);
    } else {
      let flag = true;
      apiRoleNames.forEach((item) => {
        if (!userApiRoleListMap.hasOwnProperty(item)) {
          flag = false;
        }
      });
      return flag;
    }
  } else {
    return true;
  }
}
function checkPermissionWithApiNames(apiNames) {
  const userApiRoleListMap = _getStorage("userApiRoleListMap") ? JSON.parse(_getStorage("userApiRoleListMap")) : void 0;
  if (userApiRoleListMap) {
    if (typeof apiNames === "string") {
      if (!ZWSAPIRoleMap.hasOwnProperty(apiNames)) {
        return true;
      }
      return userApiRoleListMap.hasOwnProperty(ZWSAPIRoleMap[apiNames]);
    } else {
      let flag = true;
      apiNames.forEach((item) => {
        if (ZWSAPIRoleMap.hasOwnProperty(item) && !userApiRoleListMap.hasOwnProperty(ZWSAPIRoleMap[apiNames])) {
          flag = false;
        }
      });
      return flag;
    }
  } else {
    return true;
  }
}
function checkRole(roleName) {
  if (!roleName)
    return Promise.resolve();
  const userApiRoleListMap = _getStorage("userApiRoleListMap") ? JSON.parse(_getStorage("userApiRoleListMap")) : void 0;
  if (userApiRoleListMap && !userApiRoleListMap[roleName]) {
    return handleError({
      data: {
        code: "http.403",
        error: "Forbidden",
        message: "\u4E0D\u5141\u8BB8\u8BBF\u95EE",
        status: 403
      }
    });
  }
  return Promise.resolve();
}
function fetch(params, roleName) {
  let abortController = new AbortController();
  let _checkRole = checkRole(roleName).then(() => {
    if (fetchCallback) {
      params.abortController = abortController;
      return fetchCallback(params).catch((err) => {
        return handleError(err);
      });
    } else {
      console.error(`\u672A\u8BBE\u7F6E fetch \u56DE\u8C03`);
      return handleError({
        data: {
          code: "error",
          error: "Not set fetch",
          message: "\u672A\u8BBE\u7F6E fetch \u56DE\u8C03",
          status: 404
        }
      });
    }
  });
  _checkRole.abort = abortController.abort.bind(abortController);
  return _checkRole;
}
function registerErrorCode(target) {
  Object.assign(errorCodeList, target);
}

function alertMgmtTriggerRulesGetChangedTriggerRules(reqParams) {
  return fetch({
    url: `/alert-mgmt/changed-rules`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtManagementCreateKafkaChangelog(reqParams) {
  return fetch({
    url: `/alert-mgmt/changelogs`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtAlertEventsDeleteExpireAlertEvent(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/alert-events/expire`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtAlertEventsGetAlertEvents(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/alert-events`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtAlertEventsAddOneAlertEvent(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/alert-events`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtAlertEventsDeleteAlertEvents(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/alert-events`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtAlertEventsDeleteAllAlertEventsUnderTenant(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/alert-events/all`,
    method: "DELETE",
    ...reqParams.params
  });
}
function alertMgmtAlertEventsBatchHandleEvent(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/alert-events/batch/_handle`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.request,
    ...reqParams.params
  });
}
function alertMgmtAlertEventsDownload(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/alert-events/download-record`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function alertMgmtAlertEventsGet(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/alert-events/download-record/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtAlertEventsGetOneAlertEvent(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/alert-events/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtAlertEventsHandleEvent(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/alert-events/${reqParams.id}/_handle`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtAlertEventsStatisticsStatisticsEventCount(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/statistics/count-event`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtAlertEventsStatisticsStatisticsEventDate(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/statistics/count-event-date`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtAlertEventsStatisticsStatisticsEvents(reqParams) {
  return fetch({
    url: `/alert-mgmt/data/tenants/${reqParams.tenantId}/statistics/event`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtHttpActionCreateHttpAction(reqParams) {
  return fetch({
    url: `/alert-mgmt/http-action`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtHttpActionGetHttpActionByType(reqParams) {
  return fetch({
    url: `/alert-mgmt/http-action/list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtHttpActionQueryHttpActionPage(reqParams) {
  return fetch({
    url: `/alert-mgmt/http-action/page`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtHttpActionGetHttpActionById(reqParams) {
  return fetch({
    url: `/alert-mgmt/http-action/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtHttpActionUpdateHttpActionById(reqParams) {
  return fetch({
    url: `/alert-mgmt/http-action/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtHttpActionDeleteHttpAction(reqParams) {
  return fetch({
    url: `/alert-mgmt/http-action/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsQuery(reqParams) {
  return fetch({
    url: `/alert-mgmt/rule-action/_search`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsListByRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/rule-action/list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtTriggerRulesGetRulesTenants(reqParams) {
  return fetch({
    url: `/alert-mgmt/rules/tenants`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtTriggerRulesGetOneTriggerRuleDetail(reqParams) {
  return fetch({
    url: `/alert-mgmt/rules/${reqParams.ruleId}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtManagementSyncAllRuleActionRecoveryToKafkaChangelog(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/all/rule-action-recovery/all/changelog`,
    method: "POST",
    ...reqParams.params
  });
}
function alertMgmtManagementSyncAllRuleActionToKafkaChangelog(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/all/rule-action/all/changelog`,
    method: "POST",
    ...reqParams.params
  });
}
function alertMgmtManagementSyncAllTAlertRuleToKafkaChangelog(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/all/rules/all/changelog`,
    method: "POST",
    ...reqParams.params
  });
}
function alertMgmtManagementSyncAllDigitalTwins2KafkaChangelog(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/all/rules/digital-twins/changelog`,
    method: "POST",
    ...reqParams.params
  });
}
function alertMgmtManagementSyncAllThingsRuleToKafkaChangelog(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/all/things-forward/all/changelog`,
    method: "POST",
    ...reqParams.params
  });
}
function alertMgmtUsageStatisticsGetUsageStatisticsOfAll(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/all/usage-statistics`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtUsageStatisticsGetUsageStatisticsOfTenantId(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/all/usage-statistics`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtTriggerRulesBatchUpdateTriggerRules(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/batch-rules`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtEdgeComputingGetEdgeComputingRuleIssuanceHistoryPage(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/edge-computing-rule-issuance-histories`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtEdgeComputingDeleteEdgeComputingRuleIssuanceHistory(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/edge-computing-rule-issuance-histories`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtEdgeComputingGetOneEdgeComputingRuleIssuanceHistory(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/edge-computing-rule-issuance-histories/${reqParams.historyId}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtEdgeComputingGetEdgeComputingRulePage(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/edge-computing-rules`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtEdgeComputingCreateOneEdgeComputingRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/edge-computing-rules`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtEdgeComputingGetOneEdgeComputingRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/edge-computing-rules/${reqParams.ruleId}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtEdgeComputingUpdateOneEdgeComputingRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/edge-computing-rules/${reqParams.ruleId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtEdgeComputingDeleteOneEdgeComputingRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/edge-computing-rules/${reqParams.ruleId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function alertMgmtEdgeComputingIssueEdgeComputingRuleToThings(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/edge-computing-rules/${reqParams.ruleId}/issuance`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsBuildPayload(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rule-actions/payload-script`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtTriggerRulesGetTenantTriggerRules(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtTriggerRulesCreateTriggerRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtTriggerRulesThingsLatestTriggerRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/latestRules`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtTriggerRulesGetTriggerRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtTriggerRulesUpdateTriggerRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtTriggerRulesDeleteTriggerRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsTriggerList(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsTriggerCreate(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsDeleteTriggerByIdList(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsRecoveryTriggerList(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action-recovery`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsRecoveryTriggerCreate(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action-recovery`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsRecoveryDeleteTriggerByIdList(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action-recovery`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsRecoveryTriggerGetOne(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action-recovery/${reqParams.actionId}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsRecoveryTriggerUpdateAction(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action-recovery/${reqParams.actionId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsRecoveryTriggerDeleteAction(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action-recovery/${reqParams.actionId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsRecoveryTriggerUpdateStatus(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action-recovery/${reqParams.actionId}/status/${reqParams.status}`,
    method: "PUT",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsTriggerGetOne(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action/${reqParams.actionId}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsTriggerUpdateAction(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action/${reqParams.actionId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsTriggerDeleteAction(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action/${reqParams.actionId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsTriggerUpdateStatus(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/action/${reqParams.actionId}/status/${reqParams.status}`,
    method: "PUT",
    ...reqParams.params
  });
}
function alertMgmtTriggerRulesUpdateTriggerRuleStatus(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/rules/${reqParams.ruleId}/status/${reqParams.status}`,
    method: "PUT",
    ...reqParams.params
  });
}
function alertMgmtThingsForwardRulesPage(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtThingsForwardRulesCreate(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtThingsForwardRulesGetOne(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtThingsForwardRulesUpdate(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtThingsForwardRulesDelete(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsForwardList(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}/action`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsCreate(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}/action`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsDeleteForwardByIdList(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}/action`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsGetOne(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}/action/${reqParams.actionId}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsUpdate(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}/action/${reqParams.actionId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtRuleActionsThingsForwardDeleteAction(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}/action/${reqParams.actionId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsUpdateStatus(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}/action/${reqParams.actionId}/status/${reqParams.status}`,
    method: "PUT",
    ...reqParams.params
  });
}
function alertMgmtThingsForwardRulesUpdateRuleStatus(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/things-forward/${reqParams.ruleId}/status/${reqParams.status}`,
    method: "PUT",
    ...reqParams.params
  });
}
function alertMgmtTwinsRulesGetTenantTwinsRules(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/twins-rules`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtTwinsRulesCreateTwinsRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/twins-rules`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtTwinsRulesThingsLatestTwinsRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/twins-rules/latestRules`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtTwinsRulesGetTwinsRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/twins-rules/${reqParams.ruleId}`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtTwinsRulesUpdateTwinsRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/twins-rules/${reqParams.ruleId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtTwinsRulesDeleteTwinsRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/twins-rules/${reqParams.ruleId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function alertMgmtTwinsRulesUpdateTwinsRuleStatus(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/twins-rules/${reqParams.ruleId}/status/${reqParams.status}`,
    method: "PUT",
    ...reqParams.params
  });
}
function alertMgmtRuleActionsTriggerCreate2(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/user/${reqParams.userId}/rules/${reqParams.ruleId}/action`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtUserResourceGetRuleListUnderUser(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/rules`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function alertMgmtUserResourceUpdateRuleListUnderUser(reqParams) {
  return fetch({
    url: `/alert-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/rules`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function alertMgmtThingsForwardRulesGetAllList(reqParams) {
  return fetch({
    url: `/alert-mgmt/things-forward/list`,
    method: "GET",
    ...reqParams.params
  });
}
function alertMgmtThingsForwardRulesGetOneForwardRule(reqParams) {
  return fetch({
    url: `/alert-mgmt/things-forward/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}

function connectionConnectionControllerQueryConnectionPage(reqParams) {
  return fetch({
    url: `/connection/connections`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function connectionConnectionControllerCreateConnection(reqParams) {
  return fetch({
    url: `/connection/connections`,
    method: "POST",
    data: reqParams.dto,
    ...reqParams.params
  });
}
function connectionConnectionLabelControllerQueryConnectionLabel(reqParams) {
  return fetch({
    url: `/connection/connections/labels/${reqParams.labelId}`,
    method: "GET",
    ...reqParams.params
  });
}
function connectionConnectionLabelControllerQueryConnectionLabels(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/labels`,
    method: "GET",
    ...reqParams.params
  });
}
function connectionConnectionLabelControllerDeleteConnectionLabels(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/labels/${reqParams.ids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function connectionConnectionLabelControllerCreateConnectionLabel(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/labels/${reqParams.id}/relations`,
    method: "POST",
    data: reqParams.dto,
    ...reqParams.params
  });
}
function connectionConnectionTargetControllerQueryTargets(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/targets`,
    method: "GET",
    ...reqParams.params
  });
}
function connectionConnectionTargetControllerCreateTarget(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/targets`,
    method: "POST",
    data: reqParams.dto,
    ...reqParams.params
  });
}
function connectionConnectionTargetControllerDeleteTargets(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/targets/${reqParams.ids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function connectionConnectionTargetControllerQueryTarget(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/targets/${reqParams.targetId}`,
    method: "GET",
    ...reqParams.params
  });
}
function connectionConnectionTargetControllerUpdateTarget(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/targets/${reqParams.targetId}`,
    method: "PUT",
    data: reqParams.target,
    ...reqParams.params
  });
}
function connectionConnectionTenantControllerQueryConnectionTenantsUsingGet(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/tenants`,
    method: "GET",
    ...reqParams.params
  });
}
function connectionConnectionTenantControllerDeleteConnectionTenantsUsingDelete(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/tenants/${reqParams.ids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function connectionConnectionTenantControllerCreateConnectionTenantUsingPost(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.connectionId}/tenants/${reqParams.tenantId}/relations`,
    method: "POST",
    ...reqParams.params
  });
}
function connectionConnectionControllerDeleteConnections(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.ids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function connectionConnectionControllerGetConnection(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function connectionConnectionControllerUpdateConnection(reqParams) {
  return fetch({
    url: `/connection/connections/${reqParams.id}`,
    method: "PUT",
    data: reqParams.dto,
    ...reqParams.params
  });
}
function connectionThingsMessageControllerGetMessageStatistics(reqParams) {
  return fetch({
    url: `/connection/tenants/${reqParams.tenantId}/messages/statistics`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function connectionThingsMessageControllerGetMessage(reqParams) {
  return fetch({
    url: `/connection/tenants/${reqParams.tenantId}/messages/${reqParams.correlationId}`,
    method: "GET",
    ...reqParams.params
  });
}

function controlClientTokenCreateClientToken(reqParams) {
  return fetch({
    url: `/control/client-token`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlTenantRoleMergeCopyRoles(reqParams) {
  return fetch({
    url: `/control/merge-roles`,
    method: "POST",
    ...reqParams.params
  });
}
function controlMyPrivilegeGetMyPrivileges(reqParams) {
  return fetch({
    url: `/control/privileges/self`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlSessionGetSession(reqParams) {
  return fetch({
    url: `/control/sessions`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlSessionCreateSession(reqParams) {
  return fetch({
    url: `/control/sessions`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlSessionCreateSessionTenantManager(reqParams) {
  return fetch({
    url: `/control/sessions/tenant-manager`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlSessionRefreshSession(reqParams) {
  return fetch({
    url: `/control/sessions/${reqParams.sessionId}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlSessionRemoveSession(reqParams) {
  return fetch({
    url: `/control/sessions/${reqParams.sessionId}`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlSessionGetSuperSession(reqParams) {
  return fetch({
    url: `/control/sesssions/super-session`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlTenantAPIGetTenantApiPage(reqParams) {
  return fetch({
    url: `/control/tenant-apis`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlTenantRoleRefreshDataUsingGet(reqParams) {
  return fetch({
    url: `/control/tenant/roles/menu/refresh`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlTenantRoleGetCommonRolePage(reqParams) {
  return fetch({
    url: `/control/tenants/common-roles`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlOrganizationGetList(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/organization`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlOrganizationCreate(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/organization`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function controlOrganizationGetOrganizationTree(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/organization-tree`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlOrganizationUpdate(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/organization/${reqParams.id}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlOrganizationDelete(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/organization/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function controlOrganizationGetOrganizationUserPageInfo(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/organizations/${reqParams.organizationId}/user-organization`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlOrganizationBind(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/organizations/${reqParams.organizationId}/user-organization`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlOrganizationUnbind(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/organizations/${reqParams.organizationId}/user-organization`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlUserPrivilegeCreateTenantUsersWithRoles(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/privileges`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlUserPrivilegeUpdateTenantUsersWithRoles(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/privileges`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlTenantRoleGetTenantRolePage(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/roles`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlTenantRoleCreateOneTenantRole(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/roles`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlTenantRoleDeleteTenantRoles(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/roles/${reqParams.ids}`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlTenantRoleGetOneTenantRole(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/roles/${reqParams.roleId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlTenantRoleUpdateOneTenantRole(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/roles/${reqParams.roleId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlTenantRoleUpdateApIsOfOneTenantRole(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/roles/${reqParams.roleId}/access`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlTenantRoleGetRoleMenu(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/roles/${reqParams.roleId}/menu`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlTenantRoleCreateRoleMenu(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/roles/${reqParams.roleId}/menu`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlTenantRoleUpdateRoleMenu(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/roles/${reqParams.roleId}/menu`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlTenantRoleDeleteRoleMenu(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/roles/${reqParams.roleId}/menu`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlSecretGetByPage(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/secret`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlSecretCreate(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/secret`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function controlSecretUpdate(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/secret/${reqParams.id}`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function controlSecretDelete(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/secret/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function controlUserPrivilegeGetMenuListOfTenantUser(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/users/${reqParams.userId}/menus`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlUserPrivilegeUpdateTenantUserMenus(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/users/${reqParams.userId}/menus`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlUserPrivilegeGetRoleListOfTenantUser(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/users/${reqParams.userId}/roles`,
    method: "GET",
    ...reqParams.params
  });
}
function controlUserPrivilegeUpdateTenantUserRoles(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/users/${reqParams.userId}/roles`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlUserPrivilegeCancelTenantUserRoles(reqParams) {
  return fetch({
    url: `/control/tenants/${reqParams.tenantId}/users/${reqParams.userId}/roles/${reqParams.roleIds}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function controlThirdLoginBindForSession(reqParams) {
  return fetch({
    url: `/control/third-login/session/bind`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlThirdLoginCheckForSession(reqParams) {
  return fetch({
    url: `/control/third-login/session/check`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlUsercenterGetThirdSupport(reqParams) {
  return fetch({
    url: `/control/usercenter/third-support`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlUsercenterGetVerificationCode(reqParams) {
  return fetch({
    url: `/control/usercenter/verification-codes`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function controlUserPrivilegeDeleteUserMenus(reqParams) {
  return fetch({
    url: `/control/users/menus`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function controlSessionV2DeleteSessionV(reqParams) {
  return fetch({
    url: `/control/sessions/tenant-manager`,
    method: "GET",
    ...reqParams.params
  });
}
function controlSessionV2CreateSessionV(reqParams) {
  return fetch({
    url: `/control/sessions/tenant-manager`,
    method: "POST",
    data: reqParams.apiCreateSessionV2Request,
    ...reqParams.params
  });
}

function dataMgmtDataCleaningSetCleanSpeed(reqParams) {
  return fetch({
    url: `/data-mgmt/data/clean-speed`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtDataCleaningQuickDeleteTaskList(reqParams) {
  return fetch({
    url: `/data-mgmt/data_cleaning/quick_delete_task`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtDataCleaningExecuteQuickDeleteTask(reqParams) {
  return fetch({
    url: `/data-mgmt/data_cleaning/quick_delete_task/${reqParams.id}/_execute`,
    method: "POST",
    ...reqParams.params
  });
}
function dataMgmtElasticsearchMappingMatchMappingPropertyType(reqParams) {
  return fetch({
    url: `/data-mgmt/elasticsearch/mapping/match`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtElasticsearchTemplateGet(reqParams) {
  return fetch({
    url: `/data-mgmt/elasticsearch/template/${reqParams.templateName}`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtElasticsearchTemplateSave(reqParams) {
  return fetch({
    url: `/data-mgmt/elasticsearch/template/${reqParams.templateName}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtElasticsearchTemplateDelete(reqParams) {
  return fetch({
    url: `/data-mgmt/elasticsearch/template/${reqParams.templateName}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtJobHandlerJobHandlerCancelQuickDeleteTaskGet(reqParams) {
  return fetch({
    url: `/data-mgmt/job-handler/cancel_quick_delete_task`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtJobHandlerJobHandlerCheckDeleteDataSendSmsGet(reqParams) {
  return fetch({
    url: `/data-mgmt/job-handler/check_delete_data_send_sms`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtJobHandlerJobHandlerClearIndexTaskGet(reqParams) {
  return fetch({
    url: `/data-mgmt/job-handler/clear-index-task`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtJobHandlerJobHandlerDeleteOssFileGet(reqParams) {
  return fetch({
    url: `/data-mgmt/job-handler/delete_oss_file`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtJobHandlerJobHandlerEndTaskGet(reqParams) {
  return fetch({
    url: `/data-mgmt/job-handler/end-task`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtJobHandlerJobHandlerQuickDeleteTaskGet(reqParams) {
  return fetch({
    url: `/data-mgmt/job-handler/quick_delete_task`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtJobHandlerJobHandlerStatisticsTaskGet(reqParams) {
  return fetch({
    url: `/data-mgmt/job-handler/statistics_task`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtJobHandlerJobHandlerStatisticsTaskCronGet(reqParams) {
  return fetch({
    url: `/data-mgmt/job-handler/statistics_task_cron`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtJobHandlerJobHandlerStatisticsUsageOnTimeGet(reqParams) {
  return fetch({
    url: `/data-mgmt/job-handler/statistics_usage_on_time`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtJobHandlerJobHandlerStatisticsUsageSummaryGet(reqParams) {
  return fetch({
    url: `/data-mgmt/job-handler/statistics_usage_summary`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtOpLogQueryOpLogRecords(reqParams) {
  return fetch({
    url: `/data-mgmt/maintenance/op-log`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtMessageBatchQueryResponse(reqParams) {
  return fetch({
    url: `/data-mgmt/message/info-model-category/${reqParams.infoModelCategoryId}/batch-query-response`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtStatisticsSearchCommonStatistic(reqParams) {
  return fetch({
    url: `/data-mgmt/statistics/common-statistic`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsAggregateCommonStatistic(reqParams) {
  return fetch({
    url: `/data-mgmt/statistics/common-statistic-aggregation`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsHistory(reqParams) {
  return fetch({
    url: `/data-mgmt/statistics/history`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsOriginHistory(reqParams) {
  return fetch({
    url: `/data-mgmt/statistics/origin_history`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTenant(reqParams) {
  return fetch({
    url: `/data-mgmt/statistics/tenant`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsOriginTenant(reqParams) {
  return fetch({
    url: `/data-mgmt/statistics/tenant/origin`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsOriginThingsInternal(reqParams) {
  return fetch({
    url: `/data-mgmt/statistics/tenant/things/origin`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsThings(reqParams) {
  return fetch({
    url: `/data-mgmt/statistics/tenant/${reqParams.tenantId}/things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsOriginThings(reqParams) {
  return fetch({
    url: `/data-mgmt/statistics/tenant/${reqParams.tenantId}/things/origin`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsThingsUsage(reqParams) {
  return fetch({
    url: `/data-mgmt/statistics/things-usage`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtStatisticsMethodsCreate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics-methods`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtStatisticsMethodsPage(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics-methods/page`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsMethodsGetParamFields(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics-methods/param-fields`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtStatisticsMethodsGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics-methods/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtStatisticsMethodsUpdate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics-methods/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtStatisticsMethodsDelete(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics-methods/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskUpdateBatchByIds(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/method/tasks/${reqParams.ids}`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskCreate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/tasks`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskPage(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/tasks/page`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/tasks/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskUpdate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/tasks/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskDelete(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/tasks/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskExecute(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/tasks/${reqParams.taskId}/_execute`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskUpdateStatus(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/tasks/${reqParams.taskId}/status/${reqParams.status}`,
    method: "PUT",
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskCreateStatisticsTimerTaskUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/timer-task`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskUpdateStatisticsTimerTaskUsingPut(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/timer-task/${reqParams.id}`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtStatisticSyncStatistics(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/sync`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskJrnlAggData(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/tasks_jrnl/agg`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskJrnlAggDataByTime(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/tasks_jrnl/agg-by-time`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskJrnlPage(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/tasks_jrnl/page`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskJrnlPageByDimension(reqParams) {
  return fetch({
    url: `/data-mgmt/tenant/${reqParams.tenantId}/statistics/tasks_jrnl/page-with-dimension`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtUsageStatisticsGetUsageStatisticsByTenantIdList(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/all/tenant-usage-statistics`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtUsageStatisticsGetUsageStatisticsByTenantIdListAndSort(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/all/tenant-usage-statistics-paging`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtUsageStatisticsGetUsageStatisticsOfAll(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/all/usage-statistics`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtDataCleaningCleanAllThingsData(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/clean-all-things-data`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtDataCleaningCurrentCleanTask(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/current_clean_task`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtCustomDataDownloadTemplateGetTemplateDetailByInfoModel(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/custom-download-template`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtCustomDataDownloadTemplateCreateTemplate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/custom-download-template`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtCustomDataDownloadTemplateGetTemplateDetail(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/custom-download-template/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtCustomDataDownloadTemplateUpdateTemplate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/custom-download-template/${reqParams.id}`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtCustomDataDownloadTemplateDeleteTemplate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/custom-download-template/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerListDashboardPanelUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/dashboard-panels`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerAddDashboardPanelUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/dashboard-panels`,
    method: "POST",
    data: reqParams.dashboardPanelDto,
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerGetDashboardPanelUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/dashboard-panels/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerUpdateDashboardPanelUsingPut(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/dashboard-panels/${reqParams.id}`,
    method: "PUT",
    data: reqParams.dashboardPanelDto,
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerDeleteDashboardPanelUsingDelete(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/dashboard-panels/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerUpdateDashboardUsingPut(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/dashboards/${reqParams.id}`,
    method: "PUT",
    data: reqParams.dto,
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerDeleteDashboardUsingDelete(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/dashboards/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtDataCleaningCleanDataByTenant(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtDataTransformListQuery(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data-transform-plugin`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtDataTransformCreate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data-transform-plugin`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtDataTransformPageQuery(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data-transform-plugin/page`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtDataTransformTestScript(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data-transform-plugin/run`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtDataTransformGetOne(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data-transform-plugin/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtDataTransformUpdate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data-transform-plugin/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtDataTransformDeleteOne(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data-transform-plugin/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtDataTransformUpdateStatus(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data-transform-plugin/${reqParams.id}/status/${reqParams.status}`,
    method: "PUT",
    ...reqParams.params
  });
}
function dataMgmtThingsDataGetThingsDataDownloadingRecordListUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data/downloading/list`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtThingsDataUpdateThingsDataDownloadRecordStatusUsingPut(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/data/downloading/status`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtTenantUsageEndTaskJrnl(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/end_tasks/jrnl`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtThingsDataQueryThingsDataByGroupUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/group-data`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtThingsDataQueryThingsDataByGroupWithMultiConditionUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/group-data-with-multi-condition`,
    method: "POST",
    data: reqParams.requestDto,
    ...reqParams.params
  });
}
function dataMgmtThingsDataGetThingsDataDownloadRecordUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/data/downloading/${reqParams.downloadId}`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtThingsDataReexportUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/data/downloading/${reqParams.downloadId}/_reexport`,
    method: "POST",
    ...reqParams.params
  });
}
function dataMgmtThingsDataGetGpsHistoryDataByBatchQueryUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/data/gps-history/by-batch-query`,
    method: "POST",
    data: reqParams.dto,
    ...reqParams.params
  });
}
function dataMgmtThingsDataBatchListThingsDataUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/batch/data`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtDataCleaningCleanDataByBatchQuery(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/data/by-batch-query`,
    method: "DELETE",
    params: reqParams.query,
    data: reqParams.propertyQueryList,
    ...reqParams.params
  });
}
function dataMgmtThingsDataCreateThingsDataDownloadRecordByBatchQueryUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/data/download/by-batch-query`,
    method: "POST",
    data: reqParams.dto,
    ...reqParams.params
  });
}
function dataMgmtThingsDataAggregationsThingsDataUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/${reqParams.thingsId}/_aggregations`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtThingsDataAggregationsThingsDataByEventUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/${reqParams.thingsId}/aggs/event`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtThingsDataListThingsDataUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/${reqParams.thingsId}/data`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtDataCleaningCleanDataByThings(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/${reqParams.thingsId}/data`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtThingsDataListThingsDataUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/${reqParams.thingsId}/data/_search`,
    method: "POST",
    data: reqParams.thingsDataRequestDto,
    ...reqParams.params
  });
}
function dataMgmtThingsDataCreateThingsDataDownloadRecordUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/${reqParams.thingsId}/data/download`,
    method: "POST",
    data: reqParams.dto,
    ...reqParams.params
  });
}
function dataMgmtThingsDataGetGpsHistoryDataUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/${reqParams.thingsId}/data/gps-history`,
    method: "POST",
    data: reqParams.dto,
    ...reqParams.params
  });
}
function dataMgmtThingsDataGetHistoryDataAggregationUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/${reqParams.thingsId}/history-aggregation`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtThingsDataHandleThingsLogUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/${reqParams.thingsId}/log-handle`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtThingsDataGetSignalPeriodUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-model/${reqParams.infoModelId}/things/${reqParams.thingsId}/signal-period`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtThingsDataGetThingsMessageTraceDataUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/things/${reqParams.thingsId}/message-traces`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtThingsDataGetMultiThingsDataUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/multi-things-data`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerUpdDashboardPanelMetricUsingPut(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/panel-thingsmetrics/${reqParams.id}`,
    method: "PUT",
    data: reqParams.dashboardPanelMetric,
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerDelDashboardPanelMetricUsingDelete(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/panel-thingsmetrics/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerListDashboardPanelMetricUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/panels/${reqParams.panelId}/panel-thingsmetrics`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerAddDashboardPanelMetricUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/panels/${reqParams.panelId}/panel-thingsmetrics`,
    method: "POST",
    data: reqParams.dashboardPanelMetric,
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerDeleteDashboardPanelMetricUsingDelete(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/panels/${reqParams.panelId}/panel-thingsmetrics`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtDataCleaningCreateQuickDeleteTask(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/quick_delete_task`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtDataCleaningCreateSingleIndex(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/single_index`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtThingsDataCreateSpecialThingsDataDownloadRecordUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/special-storage/data/backup`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtThingsDataGetSpecialStorageIndexListUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/special-storage/index-list`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtThingsDataDeleteSpecialStorageIndexUsingDelete(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/special-storage/${reqParams.indexName}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtStatisticsExportTransformListQuery(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/statistics-export-transform-plugin`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtStatisticsExportTransformCreate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/statistics-export-transform-plugin`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtStatisticsExportTransformGetOne(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/statistics-export-transform-plugin/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtStatisticsExportTransformUpdate(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/statistics-export-transform-plugin/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtStatisticsExportTransformDeleteOne(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/statistics-export-transform-plugin/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function dataMgmtStatisticsExportTransformUpdateStatus(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/statistics-export-transform-plugin/${reqParams.id}/status/${reqParams.status}`,
    method: "PUT",
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskJrnlCreateStatisticsDataDownloadRecordUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/tasks/${reqParams.taskId}/data/download`,
    method: "POST",
    data: reqParams.dto,
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskJrnlGetStatisticsDataDownloadRecordUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/tasks/${reqParams.taskId}/data/downloading/${reqParams.downloadId}`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtStatisticsTaskJrnlCreateAggDataDownloadRecord(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/statistics/tasks_jrnl/agg-by-time/download`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtDataCleaningTaskDocumentRemaining(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/task/document_remaining`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtThingsDataListThingsDataByBatchQueryUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/things/data/info-model/${reqParams.infoModelId}/query-by-batch`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.bodyDto,
    ...reqParams.params
  });
}
function dataMgmtDataCleaningTodoCleanTaskList(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/todo_clean_task_list`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtTenantUsageCalculateUsageOnTime(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/usage/calc-usage-on-time`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtTenantUsageUsageList(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/usage/jrnl`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtTenantUsageLatest(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/usage/latest`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtTenantUsagePercentage(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/usage/percentage`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtUserResourceGetDashboardListUnderUser(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/dashboards`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtUserResourceUpdateDashboardListUnderUser(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/dashboards`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function dataMgmtThingsDataCreateThingsData(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/data`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerListDashboardUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/dashboards`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerAddDashboardUsingPost(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/dashboards`,
    method: "POST",
    data: reqParams.dashboard,
    ...reqParams.params
  });
}
function dataMgmtDashboardControllerGetDashboardUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/tenants/${reqParams.tenantId}/dashboards/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtTestControllerAsyncSearchUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/test/async-search`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtTestControllerGetCodeVersionUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/test/code-version`,
    method: "GET",
    ...reqParams.params
  });
}
function dataMgmtTestControllerEsAsyncSearchUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/test/es-test`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtTestControllerGetServicePackageLimitUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/test/get-service-package-limit`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtTestControllerSendSageExcessEmailUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/test/send-sage-excess-email`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function dataMgmtTestControllerTestDeleteUsingGet(reqParams) {
  return fetch({
    url: `/data-mgmt/test/test-delete-expire-index`,
    method: "GET",
    ...reqParams.params
  });
}

function jobMgmtHandlerActionQueryHandlerAction(reqParams) {
  return fetch({
    url: `/job-mgmt/handler-action`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function jobMgmtHandlerActionCreateHandlerAction(reqParams) {
  return fetch({
    url: `/job-mgmt/handler-action`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function jobMgmtHandlerActionQueryHandlerActionPage(reqParams) {
  return fetch({
    url: `/job-mgmt/handler-action/page`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function jobMgmtHandlerActionGetHandlerAction(reqParams) {
  return fetch({
    url: `/job-mgmt/handler-action/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function jobMgmtHandlerActionUpdateHandlerAction(reqParams) {
  return fetch({
    url: `/job-mgmt/handler-action/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function jobMgmtHandlerActionDeleteHandlerAction(reqParams) {
  return fetch({
    url: `/job-mgmt/handler-action/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function jobMgmtOauth2TestTestGetMethod(reqParams) {
  return fetch({
    url: `/job-mgmt/oauth2/test/${reqParams.tenantId}/job/${reqParams.jobId}`,
    method: "GET",
    ...reqParams.params
  });
}
function jobMgmtJobLogCleanupJobLog(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/cleanup`,
    method: "DELETE",
    ...reqParams.params
  });
}
function jobMgmtJobLogQueryJobLog(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/job-logs`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function jobMgmtJobResultQueryPage(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/job-result`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function jobMgmtJobResultCreate(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/job-result`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function jobMgmtJobResultQueryOne(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/job-result/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function jobMgmtJobResultUpdate(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/job-result/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function jobMgmtJobResultDelete(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/job-result/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function jobMgmtJobResultQueryByJobId(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/job-result/${reqParams.jobId}/by-job`,
    method: "GET",
    ...reqParams.params
  });
}
function jobMgmtJobLogBatchDeleteJobLog(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/job/${reqParams.jobId}/logs`,
    method: "DELETE",
    ...reqParams.params
  });
}
function jobMgmtJobQueryJob(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/jobs`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function jobMgmtJobCreateJob(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/jobs`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function jobMgmtJobGetJob(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/jobs/${reqParams.jobId}`,
    method: "GET",
    ...reqParams.params
  });
}
function jobMgmtJobUpdateJob(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/jobs/${reqParams.jobId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function jobMgmtJobDeleteJob(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/jobs/${reqParams.jobId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function jobMgmtJobManualExecuteJob(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/jobs/${reqParams.jobId}/execute`,
    method: "POST",
    ...reqParams.params
  });
}
function jobMgmtJobLogDeleteJobLog(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/jobs/${reqParams.jobId}/logs/${reqParams.logId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function jobMgmtJobUpdateJobStatus(reqParams) {
  return fetch({
    url: `/job-mgmt/tenants/${reqParams.tenantId}/jobs/${reqParams.jobId}/status`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}

function mappingTempDataGetThingsIndexNameMap(reqParams) {
  return fetch({
    url: `/mapping/finder-data/things-index-name`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingTempDataGetThingsLabelInfo(reqParams) {
  return fetch({
    url: `/mapping/finder-data/things-label`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMappingGetCloneSimple(reqParams) {
  return fetch({
    url: `/mapping/info-models/clone-simple`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMappingGetDetailInfo(reqParams) {
  return fetch({
    url: `/mapping/info-models/detail-info`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingTempDataGetAlertRule(reqParams) {
  return fetch({
    url: `/mapping/kafka-cache/alert-rule`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMappingValidateBuildData(reqParams) {
  return fetch({
    url: `/mapping/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/validation-build-data`,
    method: "POST",
    data: reqParams.apiValidateBuildDataRequest,
    ...reqParams.params
  });
}
function mappingMappingValidateParseData(reqParams) {
  return fetch({
    url: `/mapping/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/validation-parse-data`,
    method: "POST",
    data: reqParams.apiValidateParseDataRequest,
    ...reqParams.params
  });
}
function mappingTempDataGetFragmentInfo(reqParams) {
  return fetch({
    url: `/mapping/vs10lr/fragment-info/${reqParams.batchId}`,
    method: "GET",
    ...reqParams.params
  });
}

function mappingMgmtCategoryQueryList(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtCategoryCreate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories`,
    method: "POST",
    data: reqParams.apiCategoryBaseRequest,
    ...reqParams.params
  });
}
function mappingMgmtCategoryTemplateGetGlobal(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories/global/template`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtCategoryTemplateUpdateGlobal(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories/global/template`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function mappingMgmtCategoryTemplateExportGlobal(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories/global/template/_export`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtCategoryGetOneByInfoModelId(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories/info-model/${reqParams.infoModelId}`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtCategoryGetOne(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories/${reqParams.categoryId}`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtCategoryUpdate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories/${reqParams.categoryId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function mappingMgmtCategoryTemplateGetOne(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories/${reqParams.categoryId}/template`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtCategoryTemplateUpdateOne(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories/${reqParams.categoryId}/template`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function mappingMgmtCategoryTemplateExportOne(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories/${reqParams.categoryId}/template/_export`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtCategoryDelete(reqParams) {
  return fetch({
    url: `/mapping-mgmt/categories/${reqParams.ids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function mappingMgmtSyncToChangelogSyncAllDbc(reqParams) {
  return fetch({
    url: `/mapping-mgmt/dbcs/all/sync`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtDbcGetOne(reqParams) {
  return fetch({
    url: `/mapping-mgmt/dbcs/${reqParams.dbcId}`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtSyncToChangelogSyncOneDbc(reqParams) {
  return fetch({
    url: `/mapping-mgmt/dbcs/${reqParams.dbcId}/sync`,
    method: "POST",
    ...reqParams.params
  });
}
function mappingMgmtIotEntityGetList4Public(reqParams) {
  return fetch({
    url: `/mapping-mgmt/entities/public`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockGetListByList(reqParams) {
  return fetch({
    url: `/mapping-mgmt/function-blocks/list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockExportFile(reqParams) {
  return fetch({
    url: `/mapping-mgmt/function-blocks/${reqParams.tenantId}/${reqParams.fnBlockId}/export`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockGetImportProgress(reqParams) {
  return fetch({
    url: `/mapping-mgmt/function-blocks/${reqParams.tenantId}/${reqParams.fnBlockId}/import`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockImportFile(reqParams) {
  return fetch({
    url: `/mapping-mgmt/function-blocks/${reqParams.tenantId}/${reqParams.fnBlockId}/import`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function mappingMgmtSyncToChangelogSyncAllInfoModelDetail(reqParams) {
  return fetch({
    url: `/mapping-mgmt/info-model-details/all/sync`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtSyncToChangelogSyncOneInfoModelDetail(reqParams) {
  return fetch({
    url: `/mapping-mgmt/info-model-details/${reqParams.infoModelId}/sync`,
    method: "POST",
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetList4All(reqParams) {
  return fetch({
    url: `/mapping-mgmt/info-models`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetInfoModelTimeoutMap(reqParams) {
  return fetch({
    url: `/mapping-mgmt/info-models/enable-timeout-map`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetInfoModelByNames(reqParams) {
  return fetch({
    url: `/mapping-mgmt/info-models/names/${reqParams.names}`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetInfoModelPwdByIds(reqParams) {
  return fetch({
    url: `/mapping-mgmt/info-models/passwords`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetList4Public(reqParams) {
  return fetch({
    url: `/mapping-mgmt/info-models/public`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetInfoModelCommon(reqParams) {
  return fetch({
    url: `/mapping-mgmt/info-models/${reqParams.infoModelId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtRelocationExportInfoModel(reqParams) {
  return fetch({
    url: `/mapping-mgmt/relocation`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtRelocationImportInfoModel(reqParams) {
  return fetch({
    url: `/mapping-mgmt/relocation`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.infoModelJson,
    ...reqParams.params
  });
}
function mappingMgmtRelocationExportInfoModelFile(reqParams) {
  return fetch({
    url: `/mapping-mgmt/relocation/_file`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtRelocationImportInfoModelFile(reqParams) {
  return fetch({
    url: `/mapping-mgmt/relocation/_file`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function mappingMgmtDbcGetList(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/dbcs`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtDbcUploadDbcFile(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/dbcs`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function mappingMgmtDbcUpdateDbcFile(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/dbcs/${reqParams.dbcId}`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function mappingMgmtDbcDeleteDbc(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/dbcs/${reqParams.dbcId}`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotEntityGetList(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/entities`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotEntityCreate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/entities`,
    method: "POST",
    data: reqParams.apiSaveIotEntityRequest,
    ...reqParams.params
  });
}
function mappingMgmtIotEntityGetOne(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/entities/${reqParams.entityId}`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtIotEntityUpdate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/entities/${reqParams.entityId}`,
    method: "PUT",
    data: reqParams.apiSaveIotEntityRequest,
    ...reqParams.params
  });
}
function mappingMgmtIotEntityDelete(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/entities/${reqParams.entityId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockGetList(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockCreate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks`,
    method: "POST",
    data: reqParams.apiCreateIotFunctionBlockRequest,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockGetOne(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks/${reqParams.fnBlockId}`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockUpdateFunctionBlock(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks/${reqParams.fnBlockId}`,
    method: "PUT",
    data: reqParams.functionBlockBase,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockDelete(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks/${reqParams.fnBlockId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockBatchUpdateSchema(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks/${reqParams.fnBlockId}/batch-schema`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockBatchDeleteSchemaProperties(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks/${reqParams.fnBlockId}/batch-schema`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockGetSchemaProperties(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks/${reqParams.fnBlockId}/schema`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockUpdateSchemaProperties(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks/${reqParams.fnBlockId}/schema`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockDeleteSchemaProperties(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks/${reqParams.fnBlockId}/schema`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotFunctionBlockPatchSchemaProperties(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/function-blocks/${reqParams.fnBlockId}/schema`,
    method: "PATCH",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetInfoModelIdsByPackageItemValue(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-model-ids`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetList(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelCreate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models`,
    method: "POST",
    data: reqParams.apiInfoModelBase,
    ...reqParams.params
  });
}
function mappingMgmtDbcCreateInfoModel4All(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models-creating-for-all`,
    method: "POST",
    data: reqParams.apiSaveIotInfoModelRequest,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelCleanAllInfoModelByTenant(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/clean`,
    method: "POST",
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetInfoModelByIds(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/ids/${reqParams.infoModelIds}`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetTenantInfoModelByNames(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/names/${reqParams.infoModelNames}`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelSavePublicInfoModelToTenant(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/public-to-tenant`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.apiInfoModelBase,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetInfoModel(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelUpdate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}`,
    method: "PUT",
    data: reqParams.apiInfoModelAllowUpdateProperties,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelDelete(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelPaddingConfiguration(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/configuration/padding`,
    method: "POST",
    data: reqParams.apiDefConfigurationRequest,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelValidateConfiguration(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/configuration/validation`,
    method: "POST",
    data: reqParams.apiValidateConfigurationRequest,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetInfoModelInternal(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/internal`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetInfoModelInternalPwd(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/internal-password`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelLabelGetList(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/labels`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelLabelCreate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/labels/${reqParams.labelId}/relation`,
    method: "POST",
    data: reqParams.apiLabelData,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelLabelDelete(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/labels/${reqParams.labelId}/relation`,
    method: "DELETE",
    ...reqParams.params
  });
}
function mappingMgmtInfoModelMappingGetOne(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/mapping`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtInfoModelMappingCreate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/mapping`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.apiSaveInfoModelMappingRequest,
    ...reqParams.params
  });
}
function mappingMgmtInfoModelMappingDelete(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/mapping`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtInfoModelMappingCreateMappingWithItem(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/mapping-with-item`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelGetInfoModelPwd(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/password`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelUpdatePwd(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/password`,
    method: "PUT",
    data: reqParams.apiSaveIotInfoModelPwdRequest,
    ...reqParams.params
  });
}
function mappingMgmtDbcUpdateInfoModel4All(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/update-for-all`,
    method: "PUT",
    data: reqParams.apiUpdateIotInfoModelRequest,
    ...reqParams.params
  });
}
function mappingMgmtIotInfoModelLabelGetFuzzyList(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/labels/${reqParams.labelId}/info-model-label-values`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtMappingRuleInfoGetList(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/mapping-rule-infos`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function mappingMgmtMappingRuleInfoCreate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/mapping-rule-infos`,
    method: "POST",
    data: reqParams.apiSaveMappingRuleInfoRequest,
    ...reqParams.params
  });
}
function mappingMgmtMappingRuleInfoBatchCreate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/mapping-rule-infos/batch`,
    method: "POST",
    data: reqParams.apiRuleInfoRequestList,
    ...reqParams.params
  });
}
function mappingMgmtMappingRuleInfoGetByName(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/mapping-rule-infos/name/${reqParams.mappingRuleInfoName}`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtMappingRuleInfoGetOne(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/mapping-rule-infos/${reqParams.mappingRuleInfoId}`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtMappingRuleInfoUpdate(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/mapping-rule-infos/${reqParams.mappingRuleInfoId}`,
    method: "PUT",
    data: reqParams.apiSaveMappingRuleInfoRequest,
    ...reqParams.params
  });
}
function mappingMgmtMappingRuleInfoDelete(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/mapping-rule-infos/${reqParams.mappingRuleInfoId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function mappingMgmtUserResourceAddInfoModelListByUser(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/users/info-models`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.addInfoIds,
    ...reqParams.params
  });
}
function mappingMgmtUserResourceDeleteInfoModelListUnderUser(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/users/info-models`,
    method: "DELETE",
    params: reqParams.query,
    data: reqParams.deleteInfoIds,
    ...reqParams.params
  });
}
function mappingMgmtUserResourceGetInfoModelListUnderUser(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/info-models`,
    method: "GET",
    ...reqParams.params
  });
}
function mappingMgmtUserResourceUpdateInfoModelListUnderUser(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/info-models`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function mappingMgmtDbcDbcMessageConfigs(reqParams) {
  return fetch({
    url: `/mapping-mgmt/tenants/${reqParams.tenantId}/dbcs/${reqParams.dbcId}/dbc_message_configs`,
    method: "GET",
    ...reqParams.params
  });
}

function notificationMailAsyncSend(reqParams) {
  return fetch({
    url: `/notification/mail/_asyncSend`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationMailSend(reqParams) {
  return fetch({
    url: `/notification/mail/_send`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationRuleActionCheckRuleActionConfig(reqParams) {
  return fetch({
    url: `/notification/rule-action/_check`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationRuleActionCheckRuleActionScript(reqParams) {
  return fetch({
    url: `/notification/rule-action/script/_check`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationSMSAsyncSend(reqParams) {
  return fetch({
    url: `/notification/sms/_asyncSend`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationSMSSend(reqParams) {
  return fetch({
    url: `/notification/sms/_send`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationVMSTenantAsyncSendVms(reqParams) {
  return fetch({
    url: `/notification/tenant/${reqParams.tenantId}/vms/_asyncSend`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationVMSTenantSendVms(reqParams) {
  return fetch({
    url: `/notification/tenant/${reqParams.tenantId}/vms/_send`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationMessageQueryAllMessages(reqParams) {
  return fetch({
    url: `/notification/tenants/${reqParams.tenantId}/messages`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function notificationPushLogsQueryPushLogs(reqParams) {
  return fetch({
    url: `/notification/tenants/${reqParams.tenantId}/push-log/message`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function notificationPushLogsDeletePushLogs(reqParams) {
  return fetch({
    url: `/notification/tenants/${reqParams.tenantId}/push-log/message`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function notificationSMSSmsPage(reqParams) {
  return fetch({
    url: `/notification/tenants/${reqParams.tenantId}/sms`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function notificationSMSTenantAsyncSend(reqParams) {
  return fetch({
    url: `/notification/tenants/${reqParams.tenantId}/sms/_asyncSend`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationSMSTenantSend(reqParams) {
  return fetch({
    url: `/notification/tenants/${reqParams.tenantId}/sms/_send`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationMessageQueryMyMessages(reqParams) {
  return fetch({
    url: `/notification/tenants/${reqParams.tenantId}/user/${reqParams.userId}/my-messages`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function notificationMessageReadMyAllMessages(reqParams) {
  return fetch({
    url: `/notification/tenants/${reqParams.tenantId}/user/${reqParams.userId}/my-messages`,
    method: "PUT",
    ...reqParams.params
  });
}
function notificationMessageReadMessages(reqParams) {
  return fetch({
    url: `/notification/tenants/${reqParams.tenantId}/user/${reqParams.userId}/read-message/${reqParams.ids}`,
    method: "PUT",
    ...reqParams.params
  });
}
function notificationVMSVmsPage(reqParams) {
  return fetch({
    url: `/notification/tenants/${reqParams.tenantId}/vms`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function notificationTestTestKafkaUsingGet(reqParams) {
  return fetch({
    url: `/notification/test-kafka`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function notificationTestTestCallUsingPost(reqParams) {
  return fetch({
    url: `/notification/testCall/${reqParams.name}`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function notificationTestTestMailUsingGet(reqParams) {
  return fetch({
    url: `/notification/testMail`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function notificationTestTestSaveTriggerRecordUsingGet(reqParams) {
  return fetch({
    url: `/notification/testSaveTriggerRecord`,
    method: "GET",
    ...reqParams.params
  });
}
function notificationTestTestSmsUsingGet(reqParams) {
  return fetch({
    url: `/notification/testSms`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function notificationTestTestZlgHttpActionUsingGet(reqParams) {
  return fetch({
    url: `/notification/testZlgHttpAction`,
    method: "GET",
    ...reqParams.params
  });
}
function notificationVMSAsyncSendVms(reqParams) {
  return fetch({
    url: `/notification/vms/_asyncSend`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function notificationVMSSendVms(reqParams) {
  return fetch({
    url: `/notification/vms/_send`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}

function optionComponentOptionTestUploadUsingPost(reqParams) {
  return fetch({
    url: `/component/option/upload`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFilemanagerComponentCategoryCategoryList(reqParams) {
  return fetch({
    url: `/out-filemanager/component/category`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentCategoryCreateCategory(reqParams) {
  return fetch({
    url: `/out-filemanager/component/category`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outFilemanagerComponentCategoryGetCategoryOrder(reqParams) {
  return fetch({
    url: `/out-filemanager/component/category/order`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentCategoryMoveCategoryOrder(reqParams) {
  return fetch({
    url: `/out-filemanager/component/category/order`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentCategoryUpdateCategory(reqParams) {
  return fetch({
    url: `/out-filemanager/component/category/${reqParams.id}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentCategoryDeleteCategory(reqParams) {
  return fetch({
    url: `/out-filemanager/component/category/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionGetComponentOption(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionCreateComponentOption(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionGetDownloadOptionInfo(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/download`,
    method: "GET",
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionDownloadOption(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/download`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionDeleteDownloadOption(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/download`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionGetDownloadOptionInfoByIdentifier(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/download/${reqParams.resourceIdentifier}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionDownloadOptionByIdentifier(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/download/${reqParams.resourceIdentifier}`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionMoveComponentOption(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/move`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionGetComponentOptionOrder(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/order`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionGetComponentOptionByResource(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/resource`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionGetComponentOptionDetail(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionUpdateComponentOption(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/${reqParams.id}`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFilemanagerComponentOptionDeleteComponentOption(reqParams) {
  return fetch({
    url: `/out-filemanager/component/option/${reqParams.id}`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentGetComponentStatistics(reqParams) {
  return fetch({
    url: `/out-filemanager/component/statistics/component`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentGetComponentStatisticsSort(reqParams) {
  return fetch({
    url: `/out-filemanager/component/statistics/component/sort`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentTriggerComponentStatistics(reqParams) {
  return fetch({
    url: `/out-filemanager/component/statistics/trigger`,
    method: "POST",
    ...reqParams.params
  });
}
function outFilemanagerComponentGetWebStatistics(reqParams) {
  return fetch({
    url: `/out-filemanager/component/statistics/web`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerPlanListLogs(reqParams) {
  return fetch({
    url: `/out-filemanager/datalogs`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerPlanClearLogs(reqParams) {
  return fetch({
    url: `/out-filemanager/datalogs`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerFileDeviceUploadFilePart(reqParams) {
  return fetch({
    url: `/out-filemanager/deviceUploadPart`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFilemanagerJobHandlerCleanOssFile(reqParams) {
  return fetch({
    url: `/out-filemanager/job-handler/clean-oss-file`,
    method: "GET",
    ...reqParams.params
  });
}
function outFilemanagerPlanListPlans(reqParams) {
  return fetch({
    url: `/out-filemanager/plans`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerPlanCreatePlan(reqParams) {
  return fetch({
    url: `/out-filemanager/plans`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerPlanDeletePlan(reqParams) {
  return fetch({
    url: `/out-filemanager/plans`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentListStatic(reqParams) {
  return fetch({
    url: `/out-filemanager/static/component`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentInteriorList(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/component`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentInteriorDelete(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/component/ids/${reqParams.ids}`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentCallList(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/component`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentCreate(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/component`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFilemanagerComponentUpdate(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/component/ids/${reqParams.ids}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerComponentDelete(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/component/ids/${reqParams.ids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outFilemanagerFileGetFile(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/files`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerFileDeleteFile(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/files`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerFileCleanFiles(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/files/clean`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerFileDownloadFile(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/files/download`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerFileListFiles(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/files/list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerPackageGetAllPackages(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/package/allPackages`,
    method: "GET",
    ...reqParams.params
  });
}
function outFilemanagerPackageGetLastPackage(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/package/lastPackage`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerPackageGetPackage(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/package/${reqParams.pkgtype}/info`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerPackageRemovePackage(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/package/${reqParams.pkgtype}/remove`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerPackageUploadPackage(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/package/${reqParams.pkgtype}/upload`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFilemanagerFileUploadFile(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/upload`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFilemanagerFileUploadFilePart(reqParams) {
  return fetch({
    url: `/out-filemanager/tenants/${reqParams.tenantId}/uploadPart`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFilemanagerFileV2GetUploadFileV(reqParams) {
  return fetch({
    url: `/out-filemanager/deviceUploadFile`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerFileV2DeviceUploadFileV(reqParams) {
  return fetch({
    url: `/out-filemanager/deviceUploadFile`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFilemanagerPackageV2GetAllPackagesV(reqParams) {
  return fetch({
    url: `/out-filemanager/package/allPackages`,
    method: "GET",
    ...reqParams.params
  });
}
function outFilemanagerPackageV2GetLastPackageV(reqParams) {
  return fetch({
    url: `/out-filemanager/package/lastPackage`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerPackageV2GetPackageV(reqParams) {
  return fetch({
    url: `/out-filemanager/package/${reqParams.pkgtype}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFilemanagerPackageV2UploadPackageV(reqParams) {
  return fetch({
    url: `/out-filemanager/package/${reqParams.pkgtype}`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFilemanagerPackageV2RemovePackageV(reqParams) {
  return fetch({
    url: `/out-filemanager/package/${reqParams.pkgtype}`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}

function outFirmwareMgmtDownloadGetDownloadUrl(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/download/url`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFirmwareMgmtFirmwareListFirmware(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFirmwareMgmtFirmwareUploadFirmware(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function outFirmwareMgmtFirmwareDelete(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFirmwareMgmtFirmwareNotifyUpgradeBatch(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/batch-notify`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outFirmwareMgmtFirmwareGetNewestFirmware(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/newest-firmware`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFirmwareMgmtFirmwareGetNewestFirmwareBatch(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/newest-firmware/batch`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFirmwareMgmtUpgradeQueryUpgradeTaskList(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/upgrade`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFirmwareMgmtUpgradeCreateUpgradeTask(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/upgrade`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.notify,
    ...reqParams.params
  });
}
function outFirmwareMgmtUpgradeEndUpgrade(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/upgrade/end`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFirmwareMgmtUpgradeStartUpgrade(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/upgrade/start`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.notify,
    ...reqParams.params
  });
}
function outFirmwareMgmtUpgradeStopUpgrade(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/upgrade/${reqParams.upgradeId}`,
    method: "PUT",
    ...reqParams.params
  });
}
function outFirmwareMgmtUpgradeDeleteUpgrade(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/upgrade/${reqParams.upgradeId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outFirmwareMgmtUpgradeRefreshUpgrade(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/upgrade/${reqParams.upgradeId}/refresh`,
    method: "PUT",
    ...reqParams.params
  });
}
function outFirmwareMgmtUpgradeQueryUpgradeThings(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/upgrade/${reqParams.upgradeId}/things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFirmwareMgmtUpgradeQueryUpgradeThingsStatistic(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/upgrade/${reqParams.upgradeId}/things/statistic`,
    method: "GET",
    ...reqParams.params
  });
}
function outFirmwareMgmtFirmwareUpdateFirmwarePublicState(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/${reqParams.firmwareId}/${reqParams.toPublic}`,
    method: "PUT",
    ...reqParams.params
  });
}
function outFirmwareMgmtFirmwareGetFirmwareDesc(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/${reqParams.modelId}/${reqParams.version}/description`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outFirmwareMgmtFirmwareNotifyUpgrade(reqParams) {
  return fetch({
    url: `/out-firmware-mgmt/tenants/${reqParams.tenantId}/firmwares/${reqParams.modelId}/${reqParams.version}/notify`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}

function outGroupMgmtGroupCountQueryConfigPage(reqParams) {
  return fetch({
    url: `/out-group-mgmt/group-count/${reqParams.tenantId}/config`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupCountCreateConfig(reqParams) {
  return fetch({
    url: `/out-group-mgmt/group-count/${reqParams.tenantId}/config`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtGroupCountQueryOneConfig(reqParams) {
  return fetch({
    url: `/out-group-mgmt/group-count/${reqParams.tenantId}/config/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupCountUpdateConfig(reqParams) {
  return fetch({
    url: `/out-group-mgmt/group-count/${reqParams.tenantId}/config/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtGroupCountDoCountDataNow(reqParams) {
  return fetch({
    url: `/out-group-mgmt/group-count/${reqParams.tenantId}/data/${reqParams.groupId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupInternalQueryList(reqParams) {
  return fetch({
    url: `/out-group-mgmt/groups`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtInternalRetrieveGroupListByThingsId(reqParams) {
  return fetch({
    url: `/out-group-mgmt/groups/device-ids/${reqParams.deviceIds}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtInternalRetrieveGroupListByThirdThingsId(reqParams) {
  return fetch({
    url: `/out-group-mgmt/info-models/${reqParams.infoModelId}/things/${reqParams.thirdThingsId}/groups`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupQueryGroupInternal(reqParams) {
  return fetch({
    url: `/out-group-mgmt/internal-groups`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtJobHandlerOutGroupMgmtJobHandlerGroupCountGet(reqParams) {
  return fetch({
    url: `/out-group-mgmt/job-handler/group-count`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtProjectGetProjects(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/project`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtProjectCreate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/project`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtProjectGetProject(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/project/${reqParams.projectId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtProjectUpdateProject(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/project/${reqParams.projectId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtProjectDeleteProject(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/project/${reqParams.projectId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outGroupMgmtProjectResourceGetResources(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/projectResource`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtProjectResourceCreateResource(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/projectResource`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtProjectResourceDeleteResource(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/projectResource`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtProjectResourceGetResourcesBatch(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/projectResource/batch`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtProjectResourceCreateResourceBatch(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/projectResource/batch`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtProjectResourceUpdateResourceBatch(reqParams) {
  return fetch({
    url: `/out-group-mgmt/project/tenants/${reqParams.tenantId}/projectResource/batch`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtUserResourceGetBindUserListUnderGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/resource/${reqParams.tenantId}/group/${reqParams.groupId}/users`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtUserResourceGetBindUserListWithoutPage(reqParams) {
  return fetch({
    url: `/out-group-mgmt/resource/${reqParams.tenantId}/group/${reqParams.groupId}/users-without-page`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtUserResourceUserGroupAuth(reqParams) {
  return fetch({
    url: `/out-group-mgmt/resource/${reqParams.tenantId}/user/${reqParams.userId}/group/${reqParams.groupId}/auth`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtUserResourceUserUnbindGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/resource/${reqParams.tenantId}/user/${reqParams.userId}/group/${reqParams.groupId}/unbind`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outGroupMgmtUserResourceGetUnbindUserListUnderGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/resource/${reqParams.tenantId}/users`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtUserResourceGetGroupListUnderUser(reqParams) {
  return fetch({
    url: `/out-group-mgmt/resource/${reqParams.tenantId}/users/${reqParams.userId}/group`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtUserResourceCreateGroupUserBind(reqParams) {
  return fetch({
    url: `/out-group-mgmt/resource/${reqParams.tenantId}/users/${reqParams.userId}/group`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtUserResourceUpdateGroupListUnderUser(reqParams) {
  return fetch({
    url: `/out-group-mgmt/resource/${reqParams.tenantId}/users/${reqParams.userId}/group`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtUserResourceUserCollectGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/resource/${reqParams.tenantId}/users/${reqParams.userId}/${reqParams.groupId}/collect`,
    method: "PUT",
    ...reqParams.params
  });
}
function outGroupMgmtUserResourceUserUnCollectGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/resource/${reqParams.tenantId}/users/${reqParams.userId}/${reqParams.groupId}/collect`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outGroupMgmtGroupStatisticsCountGroupValueCount(reqParams) {
  return fetch({
    url: `/out-group-mgmt/statistics/${reqParams.tenantId}/users/${reqParams.userId}/count-value`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupStatisticsCountGroupTopData(reqParams) {
  return fetch({
    url: `/out-group-mgmt/statistics/${reqParams.tenantId}/users/${reqParams.userId}/data`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupStatisticsCountGroupField(reqParams) {
  return fetch({
    url: `/out-group-mgmt/statistics/${reqParams.tenantId}/users/${reqParams.userId}/field`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceQueryTemplatePage(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/group-price-template`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceCreateTemplate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/group-price-template`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceQueryOneTemplate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/group-price-template/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceUpdateTemplate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/group-price-template/${reqParams.id}`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceDeleteTemplate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/group-price-template/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceQueryPage(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-price`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceCreate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-price`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceGetGroupPricePresuppose(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-price-presuppose/${reqParams.id}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceUpdateGroupPricePresuppose(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-price-presuppose/${reqParams.id}`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceQueryOne(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-price/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceUpdate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-price/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPriceDelete(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-price/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outGroupMgmtGroupStrategyCreate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-strategy`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtGroupStrategyUpdate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-strategy/strategy/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtGroupStrategyDelete(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-strategy/strategy/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outGroupMgmtGroupStrategyQueryTemplatePage(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-strategy/template`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupStrategyCreateTemplate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-strategy/template`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtGroupStrategyQueryOneTemplate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-strategy/template/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupStrategyUpdateTemplate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-strategy/template/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtGroupStrategyDeleteTemplate(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-strategy/template/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outGroupMgmtGroupStrategyQueryList(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group-strategy/${reqParams.groupId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtInternalBatchQueryGroupThingsMap(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/groups`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtInternalRetrieveAllDevicesUnderGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/groups/${reqParams.groupId}/devices`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtInternalRetrieveAllDevicesUnderUser(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/user/${reqParams.userId}/devices`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPlusRetrieveGroupList(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/group-plus`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPlusOnlineStatus(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/group-plus-online`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPlusUpdateStatus(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/group-plus/status/${reqParams.groupId}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupPlusRetrieveGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/group-plus/${reqParams.groupId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupRetrieveGroupList(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtGroupCreateGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtGroupRetrieveGroupListByDeviceIdsWithOrder(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/device-ids-ordered/${reqParams.deviceIds}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupRetrieveGroupListByDeviceIds(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/device-ids/${reqParams.deviceIds}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupRetrieveGroupListByIds(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/ids/${reqParams.groupIds}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupDeleteGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupIds}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outGroupMgmtDeviceSendCommandToDevice(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupIds}/command`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtGroupRetrieveGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outGroupMgmtGroupUpdateGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtDeviceBindDeviceToGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupId}/bind`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtDeviceBindDeviceToGroupWithInfo(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupId}/bind-with-info`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outGroupMgmtDeviceRetrieveDevicesFromGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupId}/devices`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtDeviceGetDeviceListFromGroupWithoutPage(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupId}/devices-without-page`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outGroupMgmtDeviceUnbindDeviceFromGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupId}/unbind`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outGroupMgmtDeviceUpdateExtraInfo(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupId}/${reqParams.thingsId}/ext-info`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outGroupMgmtGroupManagerDeleteAllGroups(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/manager/groups`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outGroupMgmtGroupManagerUnbindAllDevicesFromGroup(reqParams) {
  return fetch({
    url: `/out-group-mgmt/tenants/${reqParams.tenantId}/users/${reqParams.userId}/manager/groups/${reqParams.groupId}`,
    method: "DELETE",
    ...reqParams.params
  });
}

function outHmiFlowValidateFlow(reqParams) {
  return fetch({
    url: `/out-hmi/flows/${reqParams.flowUrl}`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiHMIRetrieveHmiListByRoot(reqParams) {
  return fetch({
    url: `/out-hmi/hmis`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiWebRetrieveWebListByRoot(reqParams) {
  return fetch({
    url: `/out-hmi/hmis/${reqParams.hmiId}/web`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiWebUploadWebModel(reqParams) {
  return fetch({
    url: `/out-hmi/model`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function outHmiTemplateGetTemplateList(reqParams) {
  return fetch({
    url: `/out-hmi/template`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiTemplateCreateTemplate(reqParams) {
  return fetch({
    url: `/out-hmi/template`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function outHmiTemplateGetTemplateCategoryList(reqParams) {
  return fetch({
    url: `/out-hmi/template/category`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiTemplatePostTemplateCategory(reqParams) {
  return fetch({
    url: `/out-hmi/template/category`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiTemplateGetTemplateCategoryOrder(reqParams) {
  return fetch({
    url: `/out-hmi/template/category/order`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiTemplateUpdateTemplateCategoryOrder(reqParams) {
  return fetch({
    url: `/out-hmi/template/category/order`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiTemplateUpdateTemplateCategory(reqParams) {
  return fetch({
    url: `/out-hmi/template/category/${reqParams.id}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiTemplateDeleteTemplateCategory(reqParams) {
  return fetch({
    url: `/out-hmi/template/category/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outHmiTemplateUpdateTemplate(reqParams) {
  return fetch({
    url: `/out-hmi/template/${reqParams.id}`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function outHmiTemplateDeleteTemplate(reqParams) {
  return fetch({
    url: `/out-hmi/template/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outHmiHMIRetrieveHmiListUnderManager(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/hmis`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiHMIRetrieveHmiList(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiHMICreateHmi(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiHMIRetrieveHmi(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiHMIUpdateHmi(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiHMIDeleteHmi(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outHmiDomainRetrieveDomainList(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/domain`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiDomainCreateDomain(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/domain`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiDomainRetrieveDomain(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/domain/${reqParams.domainId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiDomainUpdateDomain(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/domain/${reqParams.domainId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiDomainDeleteDomain(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/domain/${reqParams.ids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outHmiFlowRetrieveFlowList(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/flows`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiFlowCreateFlow(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/flows`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiFlowRetrieveFlow(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/flows/${reqParams.flowId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiFlowUpdateFlow(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/flows/${reqParams.flowId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiFlowDeleteFlow(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/flows/${reqParams.flowId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outHmiFlowRetrieveFlowApi(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/flows/${reqParams.flowId}/api`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiFlowRetrieveFlowState(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/flows/${reqParams.flowId}/state`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiWebRetrieveWebList(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/web`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiWebCreateWeb(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/web`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiWebDeleteWeb(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/web/${reqParams.ids}`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiWebRetrieveWeb(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/web/${reqParams.webId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiWebUpdateWeb(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/web/${reqParams.webId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiWebRetrieveReleaseWeb(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/web/${reqParams.webId}/release`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiWebUpdateReleaseStatus(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/web/${reqParams.webId}/release`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiSessionGetSession(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/web/${reqParams.webId}/session`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiSessionCreateHmiSession(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/web/${reqParams.webId}/session`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiWebGetWebRelease(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/hmis/${reqParams.hmiId}/web/${reqParams.webId}/webRelease`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiUserResourceGetUserResource(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/resource`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiUserResourceUpdateUserResource(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/resource`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.ids,
    ...reqParams.params
  });
}
function outHmiUserResourceGetUserResourceTree(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/resource-tree`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiUserResourceRetrieveFlowListUnderUser(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/resource/flows`,
    method: "GET",
    ...reqParams.params
  });
}
function outHmiUserResourceUpdateFlowListUnderUser(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/resource/flows`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiUserResourceRetrieveWebListUnderUser(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/resource/webs`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outHmiUserResourceUpdateWebListUnderUser(reqParams) {
  return fetch({
    url: `/out-hmi/tenants/${reqParams.tenantId}/users/${reqParams.userId}/resource/webs`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function outHmiWebRetrieveWebInfo(reqParams) {
  return fetch({
    url: `/out-hmi/web/info`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}

function outWebConfigConfigInfo(reqParams) {
  return fetch({
    url: `/out-web/deploy/config/info`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebConfigConfigSave(reqParams) {
  return fetch({
    url: `/out-web/deploy/config/save`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function outWebDeployWebInfo(reqParams) {
  return fetch({
    url: `/out-web/deploy/web/info`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebDeployWebList(reqParams) {
  return fetch({
    url: `/out-web/deploy/web/list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebDeployWebRelease(reqParams) {
  return fetch({
    url: `/out-web/deploy/web/release`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebDeployWebRemove(reqParams) {
  return fetch({
    url: `/out-web/deploy/web/remove`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebDeployWebSave(reqParams) {
  return fetch({
    url: `/out-web/deploy/web/save`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function outWebLicenceGetLicenceConfig(reqParams) {
  return fetch({
    url: `/out-web/licence/config`,
    method: "GET",
    ...reqParams.params
  });
}
function outWebLicenceUpdateLicenceConfig(reqParams) {
  return fetch({
    url: `/out-web/licence/config`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWebLicenceGetLicenceSecretList(reqParams) {
  return fetch({
    url: `/out-web/licence/secret`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebLicenceAddLicenceSecret(reqParams) {
  return fetch({
    url: `/out-web/licence/secret`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWebLicenceGetLicenceSecretInfo(reqParams) {
  return fetch({
    url: `/out-web/licence/secret/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWebLicenceUpdateLicenceSecretInfo(reqParams) {
  return fetch({
    url: `/out-web/licence/secret/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWebLicenceDeleteLicenceSecretInfo(reqParams) {
  return fetch({
    url: `/out-web/licence/secret/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outWebLicenceGenerationThingsLicense(reqParams) {
  return fetch({
    url: `/out-web/licence/things`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWebLogLogList(reqParams) {
  return fetch({
    url: `/out-web/log/list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebLogServiceLogDetail(reqParams) {
  return fetch({
    url: `/out-web/log/service/detail`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebLogServiceLogList(reqParams) {
  return fetch({
    url: `/out-web/log/service/list/`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebNoticeGetListByPage(reqParams) {
  return fetch({
    url: `/out-web/notice`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebNoticeCreate(reqParams) {
  return fetch({
    url: `/out-web/notice`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWebNoticeGetUserNotice(reqParams) {
  return fetch({
    url: `/out-web/notice/user/${reqParams.userId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebNoticeGetOne(reqParams) {
  return fetch({
    url: `/out-web/notice/${reqParams.noticeId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWebNoticeUpdate(reqParams) {
  return fetch({
    url: `/out-web/notice/${reqParams.noticeId}`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWebNoticeDelete(reqParams) {
  return fetch({
    url: `/out-web/notice/${reqParams.noticeId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outWebNoticeGetUserNoticeConfig(reqParams) {
  return fetch({
    url: `/out-web/notice/${reqParams.noticeId}/user/${reqParams.userId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWebNoticeUpdateUserNoticeConfig(reqParams) {
  return fetch({
    url: `/out-web/notice/${reqParams.noticeId}/user/${reqParams.userId}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebServerConfigGetServiceConfig(reqParams) {
  return fetch({
    url: `/out-web/server/config`,
    method: "GET",
    ...reqParams.params
  });
}
function outWebServerConfigUpdateServiceConfig(reqParams) {
  return fetch({
    url: `/out-web/server/config`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWebServerConfigGetServiceAdjustStrategyList(reqParams) {
  return fetch({
    url: `/out-web/service/adjustStrategy`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebServerConfigAddServiceAdjustStrategy(reqParams) {
  return fetch({
    url: `/out-web/service/adjustStrategy`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebServerConfigUpdateServiceAdjustStrategy(reqParams) {
  return fetch({
    url: `/out-web/service/adjustStrategy/${reqParams.id}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebServerConfigDeleteServiceAdjustStrategy(reqParams) {
  return fetch({
    url: `/out-web/service/adjustStrategy/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outWebServerConfigUpdateServiceReplicas(reqParams) {
  return fetch({
    url: `/out-web/service/${reqParams.service}/replicas`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebSystemValidityPeriodGetSystemValidityPeriod(reqParams) {
  return fetch({
    url: `/out-web/system-validity-period/info`,
    method: "GET",
    ...reqParams.params
  });
}
function outWebSystemValidityPeriodSaveSystemValidityPeriod(reqParams) {
  return fetch({
    url: `/out-web/system-validity-period/save`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWebThingsActiveGetThingsActiveList(reqParams) {
  return fetch({
    url: `/out-web/things-active/list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebThingsActiveGetThingsActiveStatistic(reqParams) {
  return fetch({
    url: `/out-web/things-active/statistic`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebUserActiveGetUserActiveList(reqParams) {
  return fetch({
    url: `/out-web/user-active/list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWebUserActiveGetUserActiveStatistic(reqParams) {
  return fetch({
    url: `/out-web/user-active/statistic`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}

function outWrapperAdminStatisticsThingsOrigin(reqParams) {
  return fetch({
    url: `/out-wrapper/admin/statistics/things/origin`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryBmsBcuMapping(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/tenant/${reqParams.tenantId}/IndustryES/bms-bcu-mapping`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryChargeInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.dimensionId}/IndustryES/charge`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryCountInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.dimensionId}/IndustryES/count`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryEnergyInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.dimensionId}/IndustryES/energy`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryIncomeInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.dimensionId}/IndustryES/income`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryRunningInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.dimensionId}/IndustryES/running`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryWarningInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.dimensionId}/IndustryES/warning`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryWarningCount(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.dimensionId}/IndustryES/warning/count`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryDevicesInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.groupId}/IndustryES/devices`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryFnDataGroupDisplay(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.groupId}/IndustryES/fn-data-group-display`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryBmsBcuDataInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.groupId}/IndustryES/things/${reqParams.thingsId}/data/bms-bcu/${reqParams.bmsName}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryDeviceDataInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.groupId}/IndustryES/things/${reqParams.thingsId}/data/${reqParams.dataGroupName}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryDeviceOneInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.groupId}/IndustryES/things/${reqParams.thingsId}/info`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperIndustryESQueryGroupVideoMonitorConfig(reqParams) {
  return fetch({
    url: `/out-wrapper/bigscreen/${reqParams.groupId}/IndustryES/video-monitor-config`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperCandtuGetVehicleStatusStatistic(reqParams) {
  return fetch({
    url: `/out-wrapper/candtu/bigscreen/tenant/${reqParams.tenantId}/statistic/vehicle-status/`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperCandtuGetCarInfoDataList(reqParams) {
  return fetch({
    url: `/out-wrapper/candtu/tenants/${reqParams.tenantId}/car-info/list/data`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperCandtuCreateCandtuStatisticsDataDownloadRecord(reqParams) {
  return fetch({
    url: `/out-wrapper/candtu/tenants/${reqParams.tenantId}/statistics/method/${reqParams.methodId}/tasks/${reqParams.taskId}/car-data/download`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperCandtuGetCandtuReportSummaryResultList(reqParams) {
  return fetch({
    url: `/out-wrapper/candtu/${reqParams.tenantId}/${reqParams.userId}/report/statistic-report-summary`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupIndustryEsIncomePrediction(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenant/${reqParams.tenantId}/user/${reqParams.userId}/group/${reqParams.groupId}/IndustryES/income-prediction`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupDownloadGroupAlertEvent(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/alert-event-data/download`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWrapperGroupBatchPostMessage(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/batch-messages`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWrapperGroupStatistics(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/enhance-statistics`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupEfficiency(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/group/${reqParams.groupId}/efficiency`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupGetRecalculationTask(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/group/${reqParams.groupId}/recalculation`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperGroupRecalculate(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/group/${reqParams.groupId}/recalculation`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWrapperGroupQueryThingsList(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/group/${reqParams.groupId}/things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupQueryThingsListWithoutPage(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/group/${reqParams.groupId}/things-without-page`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperGroupGetAlertEvents(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/user/${reqParams.userId}/alert-event-data`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupBindDeviceToGroupWithInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupId}/bind-with-info`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWrapperGroupUpdateGroupDeviceExtraInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/group/tenants/${reqParams.tenantId}/users/${reqParams.userId}/groups/${reqParams.groupId}/${reqParams.thingsId}/ext-info`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWrapperGroupGetReportSummaryResultList(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/IndustryES/statistic-report-summary`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupCountInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/group`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupCountList(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/group-list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupCountInfoIndustryEs(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/group/IndustryES`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupCountById(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/group/${reqParams.id}`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupCountByIdIndustryEs(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/group/${reqParams.id}/IndustryES`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperGroupCountGroupOnline(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/online-status`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupCountRecentWeek(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/recent-week`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupCountRecentWeekIndustryEs(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/recent-week/IndustryES`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupCountRecentWeekIndustryEsSy(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/recent-week/IndustryES/sy`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperGroupGetGroupCountRecentYear(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/recent-year`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperGroupGetTopGroups(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/top-groups`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupGetTopGroupsIndustryEs(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/count/top-groups/IndustryES`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperGroupCreateSummaryStatisticsDataDownloadRecord(reqParams) {
  return fetch({
    url: `/out-wrapper/group/${reqParams.tenantId}/${reqParams.userId}/method/${reqParams.methodId}/tasks/${reqParams.taskId}/statistic-report-summary`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWrapperRepairGetOne(reqParams) {
  return fetch({
    url: `/out-wrapper/repair/tenant/${reqParams.tenantId}/repair/${reqParams.repairId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperRepairDeleteOne(reqParams) {
  return fetch({
    url: `/out-wrapper/repair/tenant/${reqParams.tenantId}/repair/${reqParams.repairId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outWrapperRepairHandleRepair(reqParams) {
  return fetch({
    url: `/out-wrapper/repair/tenant/${reqParams.tenantId}/repair/${reqParams.repairId}/handle`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperRepairQueryRepairPage(reqParams) {
  return fetch({
    url: `/out-wrapper/repair/tenant/${reqParams.tenantId}/user/${reqParams.userId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperRepairCreateRepair(reqParams) {
  return fetch({
    url: `/out-wrapper/repair/tenant/${reqParams.tenantId}/user/${reqParams.userId}`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperScreenGetAlertStatistic(reqParams) {
  return fetch({
    url: `/out-wrapper/screen/statistic/alert`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperScreenGetInfoModelStatistic(reqParams) {
  return fetch({
    url: `/out-wrapper/screen/statistic/info-model`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperScreenGetDeviceOnlineStatistic(reqParams) {
  return fetch({
    url: `/out-wrapper/screen/statistic/online`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperIndustryESGetStationInfo(reqParams) {
  return fetch({
    url: `/out-wrapper/solar/tenants/${reqParams.tenantId}/group/${reqParams.groupId}/station-info`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperStatisticGetRecentSystemTpsStatistic(reqParams) {
  return fetch({
    url: `/out-wrapper/statistic/recent-system-tps-average`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperTenantsQuerySpecialPrivilegePage(reqParams) {
  return fetch({
    url: `/out-wrapper/tenant/special-privilege`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperTenantsGetTenantSpecialPrivilege(reqParams) {
  return fetch({
    url: `/out-wrapper/tenant/special-privilege/${reqParams.tenantId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperTenantsUpdateTenantSpecialPrivilege(reqParams) {
  return fetch({
    url: `/out-wrapper/tenant/special-privilege/${reqParams.tenantId}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperTenantsQueryTenantPage(reqParams) {
  return fetch({
    url: `/out-wrapper/tenant/tenants`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperCommandTemplateGetTemplateList(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/command-template`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperCommandTemplateCreate(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/command-template`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWrapperCommandTemplateGetOne(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/command-template/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperCommandTemplateUpdate(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/command-template/${reqParams.id}`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function outWrapperCommandTemplateDelete(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/command-template/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outWrapperThingsBatchRegisterThings(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/import-things`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function outWrapperMessagesQueryBlockMessageResponse(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/messages/${reqParams.messageId}/block-response`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperThingsQueryList(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperThingsRegisterThings(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/things`,
    method: "POST",
    data: reqParams.apiBaseThingsRequest,
    ...reqParams.params
  });
}
function outWrapperThingsQueryBatchById(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/things/batch/${reqParams.ids}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperThingsStatisticsThingsModelThings(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/things/statistics/model-things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperThingsQueryOne(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/things/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperMessagesSendBlockMessage(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/block-messages`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperMessagesSendSyncMessage(reqParams) {
  return fetch({
    url: `/out-wrapper/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/sync-message`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperMessagesGetCurrentSystemTimestamp(reqParams) {
  return fetch({
    url: `/out-wrapper/timestamp`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperTunnelListDeviceTunnels(reqParams) {
  return fetch({
    url: `/out-wrapper/tunnel/tenants/${reqParams.tenantId}/users/${reqParams.userId}/tunnel`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperTunnelCreateDeviceTunnel(reqParams) {
  return fetch({
    url: `/out-wrapper/tunnel/tenants/${reqParams.tenantId}/users/${reqParams.userId}/tunnel`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperTunnelUpdateDeviceTunnel(reqParams) {
  return fetch({
    url: `/out-wrapper/tunnel/tenants/${reqParams.tenantId}/users/${reqParams.userId}/tunnel/${reqParams.tunnelId}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperTunnelDeleteDeviceTunnel(reqParams) {
  return fetch({
    url: `/out-wrapper/tunnel/tenants/${reqParams.tenantId}/users/${reqParams.userId}/tunnel/${reqParams.tunnelId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outWrapperBehaviorGetBehavior(reqParams) {
  return fetch({
    url: `/out-wrapper/user/behavior`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperBehaviorCreateBehavior(reqParams) {
  return fetch({
    url: `/out-wrapper/user/behavior`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperBehaviorSortByAction(reqParams) {
  return fetch({
    url: `/out-wrapper/user/behavior/sort-by-action`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperBehaviorSortByModule(reqParams) {
  return fetch({
    url: `/out-wrapper/user/behavior/sort-by-module`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperBehaviorSortByTenant(reqParams) {
  return fetch({
    url: `/out-wrapper/user/behavior/sort-by-tenant`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperUtilsCellocationCell(reqParams) {
  return fetch({
    url: `/out-wrapper/utils/cellocation/cell`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperUtilsCellocationWifi(reqParams) {
  return fetch({
    url: `/out-wrapper/utils/cellocation/wifi`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperUtilsCalibrationTimestamp(reqParams) {
  return fetch({
    url: `/out-wrapper/utils/timestamp/calibration`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperVideoManageQueryVideos(reqParams) {
  return fetch({
    url: `/out-wrapper/video/tenants/${reqParams.tenantId}/users/${reqParams.userId}/videos`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperVideoManageAddVideos(reqParams) {
  return fetch({
    url: `/out-wrapper/video/tenants/${reqParams.tenantId}/users/${reqParams.userId}/videos`,
    method: "POST",
    data: reqParams.apiVideoBaseInfo,
    ...reqParams.params
  });
}
function outWrapperVideoManageUpdateVideos(reqParams) {
  return fetch({
    url: `/out-wrapper/video/tenants/${reqParams.tenantId}/users/${reqParams.userId}/videos/${reqParams.videoId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperVideoManageDeleteVideos(reqParams) {
  return fetch({
    url: `/out-wrapper/video/tenants/${reqParams.tenantId}/users/${reqParams.userId}/videos/${reqParams.videoId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outWrapperWorkQueryWorkPage(reqParams) {
  return fetch({
    url: `/out-wrapper/work/tenant/${reqParams.tenantId}/user/${reqParams.userId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function outWrapperWorkCreateWork(reqParams) {
  return fetch({
    url: `/out-wrapper/work/tenant/${reqParams.tenantId}/user/${reqParams.userId}`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperWorkGetOne(reqParams) {
  return fetch({
    url: `/out-wrapper/work/tenant/${reqParams.tenantId}/work/${reqParams.workId}`,
    method: "GET",
    ...reqParams.params
  });
}
function outWrapperWorkDeleteOne(reqParams) {
  return fetch({
    url: `/out-wrapper/work/tenant/${reqParams.tenantId}/work/${reqParams.workId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function outWrapperWorkHandleWork(reqParams) {
  return fetch({
    url: `/out-wrapper/work/tenant/${reqParams.tenantId}/work/${reqParams.workId}/handle`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function outWrapperThingsV2RegisterThings(reqParams) {
  return fetch({
    url: `/out-wrapper/devices`,
    method: "POST",
    data: reqParams.info,
    ...reqParams.params
  });
}

function singleCompatGetThingsList(reqParams) {
  return fetch({
    url: `/single/compat/devices`,
    method: "GET",
    ...reqParams.params
  });
}
function singleCompatRegisterThings(reqParams) {
  return fetch({
    url: `/single/compat/devices`,
    method: "POST",
    data: reqParams.info,
    ...reqParams.params
  });
}
function singleCompatGenerateThingsTokensV(reqParams) {
  return fetch({
    url: `/single/compat/mqtt/tokens`,
    method: "POST",
    data: reqParams.apiMqttTokenV2Request,
    ...reqParams.params
  });
}
function singleCompatGetUploadFileV(reqParams) {
  return fetch({
    url: `/single/compat/out-filemanager/deviceUploadFile`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleCompatDeviceUploadFileV(reqParams) {
  return fetch({
    url: `/single/compat/out-filemanager/deviceUploadFile`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function singleCompatGetAllPackagesV(reqParams) {
  return fetch({
    url: `/single/compat/out-filemanager/package/allPackages`,
    method: "GET",
    ...reqParams.params
  });
}
function singleCompatGetLastPackageV(reqParams) {
  return fetch({
    url: `/single/compat/out-filemanager/package/lastPackage`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleCompatGetPackageV(reqParams) {
  return fetch({
    url: `/single/compat/out-filemanager/package/${reqParams.pkgtype}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleCompatUploadPackageV(reqParams) {
  return fetch({
    url: `/single/compat/out-filemanager/package/${reqParams.pkgtype}`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function singleCompatRemovePackageV(reqParams) {
  return fetch({
    url: `/single/compat/out-filemanager/package/${reqParams.pkgtype}`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleCompatDeleteSessionV(reqParams) {
  return fetch({
    url: `/single/compat/sessions/tenant-manager`,
    method: "GET",
    ...reqParams.params
  });
}
function singleCompatCreateSessionV(reqParams) {
  return fetch({
    url: `/single/compat/sessions/tenant-manager`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleLorawanCommandLorawanThings(reqParams) {
  return fetch({
    url: `/single/lorawan/message`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleLorawanListMulticastGroup(reqParams) {
  return fetch({
    url: `/single/lorawan/tenants/${reqParams.tenantId}/multicast-group`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleLorawanCreateMulticastGroup(reqParams) {
  return fetch({
    url: `/single/lorawan/tenants/${reqParams.tenantId}/multicast-group`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleLorawanInfoMulticastGroups(reqParams) {
  return fetch({
    url: `/single/lorawan/tenants/${reqParams.tenantId}/multicast-group/${reqParams.ids}`,
    method: "GET",
    ...reqParams.params
  });
}
function singleLorawanUpdateMulticastGroup(reqParams) {
  return fetch({
    url: `/single/lorawan/tenants/${reqParams.tenantId}/multicast-group/${reqParams.ids}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleLorawanRemoveMulticastGroups(reqParams) {
  return fetch({
    url: `/single/lorawan/tenants/${reqParams.tenantId}/multicast-group/${reqParams.ids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function singleLorawanListMulticastGroupDevices(reqParams) {
  return fetch({
    url: `/single/lorawan/tenants/${reqParams.tenantId}/multicast-group/${reqParams.multicastGroupId}/devices`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleLorawanAddMulticastGroupDevice(reqParams) {
  return fetch({
    url: `/single/lorawan/tenants/${reqParams.tenantId}/multicast-group/${reqParams.multicastGroupId}/devices`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleLorawanRemoveMulticastGroupDevice(reqParams) {
  return fetch({
    url: `/single/lorawan/tenants/${reqParams.tenantId}/multicast-group/${reqParams.multicastGroupId}/devices`,
    method: "DELETE",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleLorawanMessageMulticastGroup(reqParams) {
  return fetch({
    url: `/single/lorawan/tenants/${reqParams.tenantId}/multicast-group/${reqParams.multicastGroupId}/message`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleLorawanRegisterLorawanThings(reqParams) {
  return fetch({
    url: `/single/lorawan/tenants/${reqParams.tenantId}/things`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleDbcSyncAllIndexToKafka(reqParams) {
  return fetch({
    url: `/single/sync/all-index`,
    method: "POST",
    ...reqParams.params
  });
}
function singleAnalysisScriptGetAnalysisScriptList(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/analysis-script`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleAnalysisScriptAddAnalysisScript(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/analysis-script`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleAnalysisScriptGetAnalysisScriptById(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/analysis-script/${reqParams.analysisScriptId}`,
    method: "GET",
    ...reqParams.params
  });
}
function singleAnalysisScriptUpdateAnalysisScript(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/analysis-script/${reqParams.analysisScriptId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleAnalysisScriptDeleteAnalysisScript(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/analysis-script/${reqParams.analysisScriptId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function singleTestProcessGetTestProcessList(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/test-process`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleTestProcessAddTestProcess(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/test-process`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleTestProcessExecuteTestProcess(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/test-process/execute`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleTestProcessGetCurrentTestProcessTask(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/test-process/execute-record/current_task`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleTestProcessGetExecuteRecord(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/test-process/execute-record/${reqParams.recordId}`,
    method: "GET",
    ...reqParams.params
  });
}
function singleTestProcessGetAnalysisReport(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/test-process/execute-record/${reqParams.recordId}/analysis-report`,
    method: "GET",
    ...reqParams.params
  });
}
function singleTestProcessUpadteExecuteRecordStatus(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/test-process/execute-record/${reqParams.recordId}/status`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleTestProcessGetTestProcessById(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/test-process/${reqParams.testProcessId}`,
    method: "GET",
    ...reqParams.params
  });
}
function singleTestProcessUpdateTestProcess(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/test-process/${reqParams.testProcessId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleTestProcessDeleteTestProcess(reqParams) {
  return fetch({
    url: `/single/tenant/${reqParams.tenantId}/test-process/${reqParams.testProcessId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function singleCarInfoGetCarInfoListInternal(reqParams) {
  return fetch({
    url: `/single/tenants/car-info/list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleThingsRegisterCandtuThings(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/candtu-things`,
    method: "POST",
    data: reqParams.apiBaseThingsRequest,
    ...reqParams.params
  });
}
function singleCarInfoAddCarInfo(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/car-info/car`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleCarInfoUpdateCarInfo(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/car-info/car`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleCarInfoDeleteCarInfo(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/car-info/car`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleCarInfoGetCarInfo(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/car-info/car/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function singleCarInfoGetCarInfoList(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/car-info/list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleDbcGetDbcChannelBindList(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dbc/channel-bind`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleDbcAddDbcChannelBind(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dbc/channel-bind`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleDbcDeleteDbcChannelBind(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dbc/channel-bind`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleDbcGetDbcChannelBind(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dbc/channel-bind/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function singleDbcUpdateDbcChannelBind(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dbc/channel-bind/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleDtcGetDtcShowCode(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dtc/dtc-code`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleDtcGetDtcContents(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dtc/file`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleDtcUploadDtcContents(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dtc/file`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleDtcUpdateDtcContents(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dtc/file`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleDtcDeleteDtcContents(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dtc/file`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleDtcGetDtcFileList(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dtc/file-list`,
    method: "GET",
    ...reqParams.params
  });
}
function singleDtcGetDtcFileTemplate(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/dtc/template-file`,
    method: "GET",
    ...reqParams.params
  });
}
function singleBindingAddEcuBinding(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/ecu/binding`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleEcuGetEcuConfiguration(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/ecu/configuration`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleEcuAddEcuConfiguration(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/ecu/configuration`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleEcuUpdateEcuConfiguration(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/ecu/configuration`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleEcuDeleteEcuConfiguration(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/ecu/configuration`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleEcuGetEcuConfigurationList(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/ecu/configuration-list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleEcuGetFileUrl(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/ecu/file`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleEcuUploadFile(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/ecu/file`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function singleFenceGetFencePage(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/fence`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleFenceAddFence(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/fence`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function singleFenceGetFenceDetail(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/fence/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function singleFenceUpdateFence(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/fence/${reqParams.id}`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function singleFenceDeleteFence(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/fence/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function singleFunctionBlockImportFunctionBlockFromFile(reqParams) {
  return fetch({
    url: `/single/tenants/${reqParams.tenantId}/function-block-import`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function singleThingsFileGetDownloadUrls(reqParams) {
  return fetch({
    url: `/single/things-file-mgmt/${reqParams.tenantId}/download-url/${reqParams.ids}`,
    method: "GET",
    ...reqParams.params
  });
}
function singleThingsFileGetThingsFileCapacity(reqParams) {
  return fetch({
    url: `/single/things-file-mgmt/${reqParams.tenantId}/file-capacity`,
    method: "GET",
    ...reqParams.params
  });
}
function singleThingsFileDeleteThingsFile(reqParams) {
  return fetch({
    url: `/single/things-file-mgmt/${reqParams.tenantId}/file-delete`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleThingsFileGetThingsFilePage(reqParams) {
  return fetch({
    url: `/single/things-file-mgmt/${reqParams.tenantId}/file-list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleThingsFileGetThingsFileStoragePage(reqParams) {
  return fetch({
    url: `/single/things-file-mgmt/${reqParams.tenantId}/file-storage`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleThingsFileCleanThingsFileStorage(reqParams) {
  return fetch({
    url: `/single/things-file-mgmt/${reqParams.tenantId}/file-storage/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function singleThingsFileRequestUploadFileCandtu(reqParams) {
  return fetch({
    url: `/single/things-file/candtu/request-upload-file`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleThingsFileGetFileUploadParameter(reqParams) {
  return fetch({
    url: `/single/things-file/file-upload-parameter`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleWorkQueryWorkPage(reqParams) {
  return fetch({
    url: `/single/work/tenant/${reqParams.tenantId}/user/${reqParams.userId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleWorkCreateWork(reqParams) {
  return fetch({
    url: `/single/work/tenant/${reqParams.tenantId}/user/${reqParams.userId}`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleWorkGetOne(reqParams) {
  return fetch({
    url: `/single/work/tenant/${reqParams.tenantId}/work/${reqParams.workId}`,
    method: "GET",
    ...reqParams.params
  });
}
function singleWorkUpdateOne(reqParams) {
  return fetch({
    url: `/single/work/tenant/${reqParams.tenantId}/work/${reqParams.workId}`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleWorkDeleteOne(reqParams) {
  return fetch({
    url: `/single/work/tenant/${reqParams.tenantId}/work/${reqParams.workId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function singleWorkHandleWork(reqParams) {
  return fetch({
    url: `/single/work/tenant/${reqParams.tenantId}/work/${reqParams.workId}/handle`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleZigbeeGetZigbeeGroups(reqParams) {
  return fetch({
    url: `/single/zigbee/tenants/${reqParams.tenantId}/multicast/group`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleZigbeeCreateGroup(reqParams) {
  return fetch({
    url: `/single/zigbee/tenants/${reqParams.tenantId}/multicast/group`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleZigbeeGetZigbeeGroup(reqParams) {
  return fetch({
    url: `/single/zigbee/tenants/${reqParams.tenantId}/multicast/group/${reqParams.multicastZigbeeGroupId}`,
    method: "GET",
    ...reqParams.params
  });
}
function singleZigbeeUpdateZigbeeGroup(reqParams) {
  return fetch({
    url: `/single/zigbee/tenants/${reqParams.tenantId}/multicast/group/${reqParams.multicastZigbeeGroupId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleZigbeeDeleteZigbeeGroup(reqParams) {
  return fetch({
    url: `/single/zigbee/tenants/${reqParams.tenantId}/multicast/group/${reqParams.multicastZigbeeGroupId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function singleZigbeeSendMessageZigbeeGroup(reqParams) {
  return fetch({
    url: `/single/zigbee/tenants/${reqParams.tenantId}/multicast/group/${reqParams.multicastZigbeeGroupId}/messages`,
    method: "PUT",
    data: reqParams.payload,
    ...reqParams.params
  });
}
function singleZigbeeGetZigbeeMembers(reqParams) {
  return fetch({
    url: `/single/zigbee/tenants/${reqParams.tenantId}/multicast/member`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function singleZigbeeCreateMember(reqParams) {
  return fetch({
    url: `/single/zigbee/tenants/${reqParams.tenantId}/multicast/member`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function singleZigbeeDeleteZigbeeMember(reqParams) {
  return fetch({
    url: `/single/zigbee/tenants/${reqParams.tenantId}/multicast/member`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}

function tenantTenantQueryAllTenant(reqParams) {
  return fetch({
    url: `/tenant/all/tenants`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingPackageGetPackageUsageStatistics(reqParams) {
  return fetch({
    url: `/tenant/billing/all/usage-statistics`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingPackageItemGetPackageContenItemList(reqParams) {
  return fetch({
    url: `/tenant/billing/content/item`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingPackageItemAddPackageContenItem(reqParams) {
  return fetch({
    url: `/tenant/billing/content/item`,
    method: "POST",
    data: reqParams.apiBasePackageItem,
    ...reqParams.params
  });
}
function tenantBillingPackageItemGetPackageContenItemList4Tenant(reqParams) {
  return fetch({
    url: `/tenant/billing/content/item/tenant`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingPackageItemUpdatePackageContenItem(reqParams) {
  return fetch({
    url: `/tenant/billing/content/item/${reqParams.itemId}`,
    method: "PUT",
    data: reqParams.apiBasePackageItem,
    ...reqParams.params
  });
}
function tenantBillingPackageItemDelPackageContenItem(reqParams) {
  return fetch({
    url: `/tenant/billing/content/item/${reqParams.itemId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantBillingJobHandlerCheckPackageExpire(reqParams) {
  return fetch({
    url: `/tenant/billing/job-handler/check-expire-packages`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantBillingJobHandlerNotifyExpirePackageTenant(reqParams) {
  return fetch({
    url: `/tenant/billing/job-handler/notify-expire-package-tenant`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantBillingJobHandlerSyncPackageChangeToKafka(reqParams) {
  return fetch({
    url: `/tenant/billing/job-handler/sync-package-change-to-kafka`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingOrderListOrderByAdmin(reqParams) {
  return fetch({
    url: `/tenant/billing/order`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingOrderDownloadOrderByAdmin(reqParams) {
  return fetch({
    url: `/tenant/billing/order/download`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingPackageGetPackageAllList(reqParams) {
  return fetch({
    url: `/tenant/billing/packages`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingPackageGetPackageSortList(reqParams) {
  return fetch({
    url: `/tenant/billing/packages`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantBillingSyncInfoSyncPakcageToKafka(reqParams) {
  return fetch({
    url: `/tenant/billing/packages/all/sync`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingPackageUpdatePackageContent(reqParams) {
  return fetch({
    url: `/tenant/billing/packages/${reqParams.id}/content`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantBillingStageDiscountListStageDiscount(reqParams) {
  return fetch({
    url: `/tenant/billing/stage-dicount`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingStageDiscountAddStageDiscount(reqParams) {
  return fetch({
    url: `/tenant/billing/stage-dicount`,
    method: "POST",
    data: reqParams.stageDiscountInfo,
    ...reqParams.params
  });
}
function tenantBillingStageDiscountUpdateStageDiscount(reqParams) {
  return fetch({
    url: `/tenant/billing/stage-dicount/${reqParams.stageDiscountId}`,
    method: "PUT",
    data: reqParams.stageDiscountInfo,
    ...reqParams.params
  });
}
function tenantBillingStageDiscountDeleteStageDiscount(reqParams) {
  return fetch({
    url: `/tenant/billing/stage-dicount/${reqParams.stageDiscountId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantBillingCouponSysGetCouponsSysList(reqParams) {
  return fetch({
    url: `/tenant/billing/sys/coupon`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingCouponSysAddCouponSys(reqParams) {
  return fetch({
    url: `/tenant/billing/sys/coupon`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantBillingCouponSysDelCouponSys(reqParams) {
  return fetch({
    url: `/tenant/billing/sys/coupon`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingCouponSysUploadCouponImage(reqParams) {
  return fetch({
    url: `/tenant/billing/sys/coupon/file`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function tenantBillingCouponSysGetOneById(reqParams) {
  return fetch({
    url: `/tenant/billing/sys/coupon/${reqParams.couponId}`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantBillingCouponSysUpdateCouponSys(reqParams) {
  return fetch({
    url: `/tenant/billing/sys/coupon/${reqParams.couponId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantBillingCouponTenantGetTenantDrawedCoupons(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/coupon`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingCouponTenantDrawCouponSys(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/coupon`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingCouponTenantGetTenantCouponsSys(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/couponSys`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantBillingOrderListOrder(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/order`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingOrderAddOrder(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/order`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantBillingOrderGetOrderAmount(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/order/amount`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantBillingOrderUpdateOrder(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/order/${reqParams.orderId}/cancel`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantBillingOrderCancelOrder(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/order/${reqParams.orderId}/cancel`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantBillingOrderPayForOrder(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/order/${reqParams.orderId}/pay`,
    method: "POST",
    ...reqParams.params
  });
}
function tenantBillingOrderRefundForOrder(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/order/${reqParams.orderId}/refund`,
    method: "POST",
    ...reqParams.params
  });
}
function tenantBillingOrderUploadOrderReceipt(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/order/${reqParams.orderId}/uploadReceipt`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function tenantBillingPackageGetPackage(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/package`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingPackageGetPackages(reqParams) {
  return fetch({
    url: `/tenant/billing/tenants/${reqParams.tenantId}/packages`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingToolsAssessDeploy(reqParams) {
  return fetch({
    url: `/tenant/billing/tools/assessDeploy`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantBillingToolsAssessTps(reqParams) {
  return fetch({
    url: `/tenant/billing/tools/assessTps`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantBillingToolsRemoveKafkaPackage(reqParams) {
  return fetch({
    url: `/tenant/billing/tools/remove-kafka-package`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantBillingOrderPayback(reqParams) {
  return fetch({
    url: `/tenant/billing/${reqParams.payType}/payback`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantInternalSendSms(reqParams) {
  return fetch({
    url: `/tenant/internal/user/sms`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserIsManager(reqParams) {
  return fetch({
    url: `/tenant/is-manager`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantLabelsLabelsCheck(reqParams) {
  return fetch({
    url: `/tenant/labels-check`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantMenuGetTenantMenu(reqParams) {
  return fetch({
    url: `/tenant/menu`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantMenuCreateTenantMenu(reqParams) {
  return fetch({
    url: `/tenant/menu`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantMenuUpdateTenantMenu(reqParams) {
  return fetch({
    url: `/tenant/menu`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantMenuDeleteTenantMenu(reqParams) {
  return fetch({
    url: `/tenant/menu`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantMenuCheckMenuField(reqParams) {
  return fetch({
    url: `/tenant/menu/check/menu_field`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantMenuMoveTenantMenu(reqParams) {
  return fetch({
    url: `/tenant/menu/move`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantAuthenticationPhoneAuthentication(reqParams) {
  return fetch({
    url: `/tenant/phone-authentication/${reqParams.phone}/${reqParams.code}`,
    method: "POST",
    ...reqParams.params
  });
}
function tenantTenantPlatformCreatePlatform(reqParams) {
  return fetch({
    url: `/tenant/platfrom`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantPlatformGetPlatform(reqParams) {
  return fetch({
    url: `/tenant/platfrom/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantPlatformUpdatePlatform(reqParams) {
  return fetch({
    url: `/tenant/platfrom/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantPlatformDeletePlatform(reqParams) {
  return fetch({
    url: `/tenant/platfrom/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantTenantPlatformGetPlatformList(reqParams) {
  return fetch({
    url: `/tenant/platfroms`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserResetPasswordByVerificationCode(reqParams) {
  return fetch({
    url: `/tenant/reset-password`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function tenantTenantSpecialAuthorityQuerySpecialAuthorityList(reqParams) {
  return fetch({
    url: `/tenant/special_authority`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantSpecialAuthorityCreateSpecialAuthority(reqParams) {
  return fetch({
    url: `/tenant/special_authority`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantSpecialAuthorityQueryTenantListBySpecialAuthority(reqParams) {
  return fetch({
    url: `/tenant/special_authority/tenant`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantSpecialAuthorityAddTenantToSpecialAuthority(reqParams) {
  return fetch({
    url: `/tenant/special_authority/tenant`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantSpecialAuthorityDeleteTenantFromSpecialAuthority(reqParams) {
  return fetch({
    url: `/tenant/special_authority/tenant`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantSpecialAuthorityQuerySpecialAuthorityListByTenant(reqParams) {
  return fetch({
    url: `/tenant/special_authority/tenant/${reqParams.tenantId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantSpecialAuthorityUpdateSpecialAuthority(reqParams) {
  return fetch({
    url: `/tenant/special_authority/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantSpecialAuthorityDeleteSpecialAuthority(reqParams) {
  return fetch({
    url: `/tenant/special_authority/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantTenantQueryTenantAuditStatistic(reqParams) {
  return fetch({
    url: `/tenant/tenant-audit-statistic`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantQueryTenantAuditPage(reqParams) {
  return fetch({
    url: `/tenant/tenant-audits`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantQueryTenantDetail(reqParams) {
  return fetch({
    url: `/tenant/tenant-detail`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantAuthenticationTenantManagerDispose(reqParams) {
  return fetch({
    url: `/tenant/tenant-manager-dispose`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantQueryTenantPage(reqParams) {
  return fetch({
    url: `/tenant/tenants`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantCreateByAdministrator(reqParams) {
  return fetch({
    url: `/tenant/tenants`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantExportDownloadCsvFile(reqParams) {
  return fetch({
    url: `/tenant/tenants-csv-file`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantManagementSyncAllTenantToKafkaChangelog(reqParams) {
  return fetch({
    url: `/tenant/tenants/all/changelog`,
    method: "POST",
    ...reqParams.params
  });
}
function tenantTenantGetSpecOfAll(reqParams) {
  return fetch({
    url: `/tenant/tenants/all/specification`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantGetUsageStatisticsOfAll(reqParams) {
  return fetch({
    url: `/tenant/tenants/all/usage-statistics`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantGetUserStatisticsOfAll(reqParams) {
  return fetch({
    url: `/tenant/tenants/all/user-statistics`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUserQueryUserInfoList(reqParams) {
  return fetch({
    url: `/tenant/tenants/users-info`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantBatchDeleteTenants(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.ids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantTenantUpdateOneTenantBasic(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantAuditTenant(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/audit/${reqParams.pass}`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantGetTenantCustomizationByTenantId(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/customization`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUpdateTenantCustomization(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/customization`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantLabelsQueryList(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/labels`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantLabelsCreate(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/labels`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantLabelsQueryListBatch(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/labels/batch`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantLabelsDelete(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/labels/${reqParams.ids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantTenantLabelsGetOne(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/labels/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantLabelsUpdate(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/labels/${reqParams.id}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantGetTenantSpecByTenantId(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/specification`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUpdateTenantSpec(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/specification`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserGetTenantManagerDetail(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/tenant-manager`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUserQueryTenantUserPage(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserAddTenantUser(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserDeleteTenantUserBatch(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserQueryTenantUserInfoList(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users-info`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserQueryTenantUserTree(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users-tree`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUserQueryTenantUserPublicProfile(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/public-profile`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserGetOneTenantUser(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUserUpdateOneTenantUser(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserDeleteTenantUser(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantTenantUserFindAllSubUsers(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}/all-subusers`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUserFindAllSubUsersWithAuth(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}/all-subusers-with-auth`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserGetIsUserParent(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}/is-parent`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserGetUserLastParent(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}/last-parent`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUserMessageGetCurrentUserMessage(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}/message`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserMessageUpdateUserMessageStatus(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}/message`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserGetUserParents(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}/parents`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUserResetTenantUserPassword(reqParams) {
  return fetch({
    url: `/tenant/tenants/${reqParams.tenantId}/users/${reqParams.userId}/reset-password`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantSimPoolQueryConfigInfo(reqParams) {
  return fetch({
    url: `/tenant/third/sim-pool/config`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantSimPoolQueryPage(reqParams) {
  return fetch({
    url: `/tenant/third/sim-pool/${reqParams.tenantId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantSimPoolCreateSimPool(reqParams) {
  return fetch({
    url: `/tenant/third/sim-pool/${reqParams.tenantId}`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantSimPoolRefreshAllPool(reqParams) {
  return fetch({
    url: `/tenant/third/sim-pool/${reqParams.tenantId}`,
    method: "PUT",
    ...reqParams.params
  });
}
function tenantTenantSimPoolRefreshSimPool(reqParams) {
  return fetch({
    url: `/tenant/third/sim-pool/${reqParams.tenantId}/${reqParams.id}`,
    method: "PUT",
    ...reqParams.params
  });
}
function tenantTenantSimPoolDeleteSimPool(reqParams) {
  return fetch({
    url: `/tenant/third/sim-pool/${reqParams.tenantId}/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantTenantAuthenticationSuperAuthentication(reqParams) {
  return fetch({
    url: `/tenant/user-authentication/${reqParams.username}`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantAuthenticationUserAuthentication(reqParams) {
  return fetch({
    url: `/tenant/user-authentication/${reqParams.username}`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserMessageGetByPage(reqParams) {
  return fetch({
    url: `/tenant/user-message`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserMessageCreateUserMessage(reqParams) {
  return fetch({
    url: `/tenant/user-message`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function tenantTenantUserMessageDelete(reqParams) {
  return fetch({
    url: `/tenant/user-message/${reqParams.userMessageId}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantTenantUserMessageUpdateMessageStatus(reqParams) {
  return fetch({
    url: `/tenant/user-message/${reqParams.userMessageId}/status`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserRegisterValidate(reqParams) {
  return fetch({
    url: `/tenant/user-tenant-validate`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserRegisterValidateZws(reqParams) {
  return fetch({
    url: `/tenant/user-tenant-validate-zws`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserRegisterTenantAndUser(reqParams) {
  return fetch({
    url: `/tenant/user-tenants`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserRegisterSubUser(reqParams) {
  return fetch({
    url: `/tenant/user-tenants/sub-user`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserAttrGetByPage(reqParams) {
  return fetch({
    url: `/tenant/user/attr`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserAttrCreate(reqParams) {
  return fetch({
    url: `/tenant/user/attr`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function tenantTenantUserAttrUpdate(reqParams) {
  return fetch({
    url: `/tenant/user/attr`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserAttrUploadFile(reqParams) {
  return fetch({
    url: `/tenant/user/attr/file`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.data,
    ...reqParams.params
  });
}
function tenantTenantUserAttrDataMigrationUsingGet(reqParams) {
  return fetch({
    url: `/tenant/user/attr/tmp`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserAttrGetTryLoginLog(reqParams) {
  return fetch({
    url: `/tenant/user/attr/try-login-log`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserAttrAddTryLoginLog(reqParams) {
  return fetch({
    url: `/tenant/user/attr/try-login-log`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserAttrDelete(reqParams) {
  return fetch({
    url: `/tenant/user/attr/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function tenantTenantUserGetCurrentUser(reqParams) {
  return fetch({
    url: `/tenant/users/self`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUserUpdateCurrentUser(reqParams) {
  return fetch({
    url: `/tenant/users/self`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserUpdateCurrentUserAvatar(reqParams) {
  return fetch({
    url: `/tenant/users/self/avatar`,
    method: "PUT",
    data: reqParams.data,
    ...reqParams.params
  });
}
function tenantTenantUserGetUserConfigInfo(reqParams) {
  return fetch({
    url: `/tenant/users/self/config`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserUpdateUserConfigInfo(reqParams) {
  return fetch({
    url: `/tenant/users/self/config`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.value,
    ...reqParams.params
  });
}
function tenantTenantUserDelUserConfig(reqParams) {
  return fetch({
    url: `/tenant/users/self/config`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserGetCurrentUserCustomization(reqParams) {
  return fetch({
    url: `/tenant/users/self/customization`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantUserUpdateCurrentUserSystemSet(reqParams) {
  return fetch({
    url: `/tenant/users/self/customization`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserUpdateCurrentUserEmail(reqParams) {
  return fetch({
    url: `/tenant/users/self/email`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserUpdateCurrentUserMobile(reqParams) {
  return fetch({
    url: `/tenant/users/self/mobile`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserUpdateCurrentUserPassword(reqParams) {
  return fetch({
    url: `/tenant/users/self/password`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserGetTenantOfCurrentUser(reqParams) {
  return fetch({
    url: `/tenant/users/self/tenant`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUserUpdateTenantOfCurrentUser(reqParams) {
  return fetch({
    url: `/tenant/users/self/tenant`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserGetTenantSpecOfCurrentUser(reqParams) {
  return fetch({
    url: `/tenant/users/self/tenant-spec`,
    method: "GET",
    ...reqParams.params
  });
}
function tenantTenantUserUpdateTenantSpecOfCurrentUser(reqParams) {
  return fetch({
    url: `/tenant/users/self/tenant-spec`,
    method: "PUT",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantUserWrittenOffCurrentUser(reqParams) {
  return fetch({
    url: `/tenant/users/self/written-off`,
    method: "PUT",
    ...reqParams.params
  });
}
function tenantTenantVerificationCodesQueryVerificationCodeList(reqParams) {
  return fetch({
    url: `/tenant/verification-codes`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function tenantTenantVerificationCodesSendVerificationCode(reqParams) {
  return fetch({
    url: `/tenant/verification-codes`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantZwsThirdLoginCreateAuth(reqParams) {
  return fetch({
    url: `/tenant/zwsthird-login/auth`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantZwsThirdLoginBindUser(reqParams) {
  return fetch({
    url: `/tenant/zwsthird-login/bind`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantZwsThirdLoginBindUserFromUc(reqParams) {
  return fetch({
    url: `/tenant/zwsthird-login/bind-from-uc`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function tenantTenantZwsThirdLoginCheckAuth(reqParams) {
  return fetch({
    url: `/tenant/zwsthird-login/check`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}

function thingsThingsGetThingsOfInfomodel(reqParams) {
  return fetch({
    url: `/things/info-models/${reqParams.infoModelIds}/things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsDigitalTwinThingsBatchUpdate(reqParams) {
  return fetch({
    url: `/things/info-models/${reqParams.infoModelId}/digital-twin-things/${reqParams.thirdThingsId}/batch-update`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsThingsCheckThings(reqParams) {
  return fetch({
    url: `/things/info-models/${reqParams.infoModelId}/things/${reqParams.thirdThingsId}/check`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsQueryChildrenThings(reqParams) {
  return fetch({
    url: `/things/info-models/${reqParams.infoModelId}/things/${reqParams.thirdThingsId}/children-things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsQueryChildrenThingsInfoModels(reqParams) {
  return fetch({
    url: `/things/info-models/${reqParams.infoModelId}/things/${reqParams.thirdThingsId}/children-things/info-models`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsLabelQueryThingsLabels(reqParams) {
  return fetch({
    url: `/things/info-models/${reqParams.infoModelId}/things/${reqParams.thirdThingsId}/labels`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsQueryParentThings(reqParams) {
  return fetch({
    url: `/things/info-models/${reqParams.infoModelId}/things/${reqParams.thirdThingsId}/parents`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsJobHandlerCalThingsUsage(reqParams) {
  return fetch({
    url: `/things/job-handler/cal-things-usage`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsJobHandlerCalThingsUsage10Min(reqParams) {
  return fetch({
    url: `/things/job-handler/cal-things-usage-10min`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsJobHandlerCheckThingsOffline(reqParams) {
  return fetch({
    url: `/things/job-handler/check-things-offline`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsJobHandlerCleanupThingsMessages(reqParams) {
  return fetch({
    url: `/things/job-handler/cleanup-things-messages`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsJobHandlerRefreshThingsApn(reqParams) {
  return fetch({
    url: `/things/job-handler/refresh-things-apn`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsMaintenanceQueryLogoutThingsList(reqParams) {
  return fetch({
    url: `/things/maintance/logout-things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsMaintenanceQueryListFromMqtt(reqParams) {
  return fetch({
    url: `/things/maintance/mqtt/things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsMaintenanceQueryList(reqParams) {
  return fetch({
    url: `/things/maintance/things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsMaintenanceQueryLogoutHistoryList(reqParams) {
  return fetch({
    url: `/things/maintance/${reqParams.thingsId}/logout-history`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsMaintenanceSyncThingsChannel(reqParams) {
  return fetch({
    url: `/things/maintenance/sync-things-channel`,
    method: "PUT",
    ...reqParams.params
  });
}
function thingsThingsMaintenanceQuerySyncTHingsSelectorInfo(reqParams) {
  return fetch({
    url: `/things/maintenance/sync-things-label`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsMaintenanceSyncThingsSelectorInfo(reqParams) {
  return fetch({
    url: `/things/maintenance/sync-things-label`,
    method: "PUT",
    ...reqParams.params
  });
}
function thingsMessagesBatchQueryMessageResponse(reqParams) {
  return fetch({
    url: `/things/messages/response`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsMessagesBatchQueryRangeMessageResponse(reqParams) {
  return fetch({
    url: `/things/messages/response`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsThingsMqttGenerateThingsTokens(reqParams) {
  return fetch({
    url: `/things/mqtt/tokens`,
    method: "POST",
    data: reqParams.apiMqttTokenRequest,
    ...reqParams.params
  });
}
function thingsThingsMqttGenerateThingsLoginByTenantTokensV(reqParams) {
  return fetch({
    url: `/things/mqtt/tokens/login-by-tenant`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsUsageStatisticsGetUsageStatisticsOfAll(reqParams) {
  return fetch({
    url: `/things/tenants/all/usage-statistics`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsMessagesPostStatelessMessage(reqParams) {
  return fetch({
    url: `/things/tenants/messages`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsMessagesHandleMessageResponse(reqParams) {
  return fetch({
    url: `/things/tenants/messages/response-handle`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsThingsUpdateIndexName(reqParams) {
  return fetch({
    url: `/things/tenants/things/${reqParams.thingsId}/_single_index`,
    method: "POST",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsGetSingleIndexList(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantIdStr}/single-indeces`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsUpdateThingsUsageList(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/_updateUsageList`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsMessagesPostBatchMessageUnderTenantByThingsSelector(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/batch-messages`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsMessagesQueryList(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/correlation-id/${reqParams.correlationId}/message`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsDigitalTwinThingsQueryList(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/digital-twin-things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsDigitalTwinThingsQueryOne(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/digital-twin-things/${reqParams.thingsId}`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsDigitalTwinThingsUpdate(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/digital-twin-things/${reqParams.thingsId}`,
    method: "POST",
    data: reqParams.apiUpdateDigitalTwinDevice,
    ...reqParams.params
  });
}
function thingsThingsBatchRegisterThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/import-things`,
    method: "POST",
    data: reqParams.data,
    ...reqParams.params
  });
}
function thingsThingsGetCurrentImportTask(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/import-things/current_task`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsUpdateImportThingsProgressStatus(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/import-things/status`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsGetBatchImportThingsProgress(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/import-things/${reqParams.importId}`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsGetThingsNumber(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/info-model-ids/${reqParams.infoModelIds}/things/number`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsGetThingsNumberForInternal(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/info-model-ids/${reqParams.infoModelIds}/things/number-for-internal`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsInfoModelQueryList(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/info-model-list`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsThingsInfoByThirdThingsIds(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/things/${reqParams.thirdThingsIds}`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsForceThingsOfflineForThirdThingsId(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/info-models/${reqParams.infoModelId}/things/${reqParams.thirdThingsId}/force-offline`,
    method: "PUT",
    ...reqParams.params
  });
}
function thingsThingsLabelDelete(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/labels/relations/${reqParams.rids}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function thingsThingsLabelQueryValueListByLabel(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/labels/${reqParams.labelId}/things-label-values`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsMessagesGetBatchMessagePage(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/message-batches/${reqParams.batchNo}/messages`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsMessagesPostMessageUnderTenantByThingsSelector(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/messages`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsMessagesQueryMessageResponse(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/messages/${reqParams.messageIds}/response`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsMqttGetThingsNativeTokens(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/mqtt/native/tokens`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsMqttGenerateThingsNativeTokens(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/mqtt/native/tokens`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsThingsBatchQueryChildrenThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/parent-things/${reqParams.parentThingsIds}/children-things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsStatisticsGetThingsModelThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/statistics/model-things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsStatisticsGetThingsNormalFault(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/statistics/normal-fault`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsStatisticsGetThingsOnlineOffline(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/statistics/online-offline`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsQueryList(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsRegisterThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things`,
    method: "POST",
    data: reqParams.apiBaseThingsRequest,
    ...reqParams.params
  });
}
function thingsThingsVerificationCreate(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things-verification`,
    method: "POST",
    data: reqParams.request,
    ...reqParams.params
  });
}
function thingsThingsVerificationPageQuery(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things-verification/page`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsVerificationGetOne(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things-verification/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsVerificationUpdate(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things-verification/${reqParams.id}`,
    method: "PUT",
    data: reqParams.request,
    ...reqParams.params
  });
}
function thingsThingsVerificationDeleteOne(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things-verification/${reqParams.id}`,
    method: "DELETE",
    ...reqParams.params
  });
}
function thingsThingsVerificationUpdateStatus(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things-verification/${reqParams.id}/status/${reqParams.status}`,
    method: "PUT",
    ...reqParams.params
  });
}
function thingsThingsBatchBindThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/batch-bind/children-things`,
    method: "POST",
    data: reqParams.info,
    ...reqParams.params
  });
}
function thingsMessagesBatchPostMessage(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/batch-messages`,
    method: "POST",
    data: reqParams.apiBatchSendMessageRequest,
    ...reqParams.params
  });
}
function thingsThingsBatchUnBindThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/batch-unbind/children-things`,
    method: "POST",
    data: reqParams.info,
    ...reqParams.params
  });
}
function thingsThingsClearBindThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/batch-unbind/children-things/clear`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.info,
    ...reqParams.params
  });
}
function thingsThingsCheckCreateThingsEnable(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/check`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsCleanAllThingsByTenant(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/clean`,
    method: "POST",
    ...reqParams.params
  });
}
function thingsThingsDownloadThingsFileByTenant(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/download-things-file`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsQueryGwThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/gw-tings/${reqParams.thingsId}`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsUserResourceGetSubUserPageByThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/sub-users`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsQueryAllList(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/without-page`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsDelete(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.ids}`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsQueryOne(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.id}`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsUpdate(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.id}`,
    method: "PUT",
    data: reqParams.apiBaseThingsRequest,
    ...reqParams.params
  });
}
function thingsThingsUpdateThingsApn(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.id}/apn`,
    method: "PUT",
    ...reqParams.params
  });
}
function thingsThingsBatchUpdateThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.infoModelId}/batch-update`,
    method: "POST",
    data: reqParams.apiBatchUpdateThingsRequest,
    ...reqParams.params
  });
}
function thingsThingsBatchUpdateConfiguration(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.infoModelId}/batch-update-configuration`,
    method: "POST",
    data: reqParams.apiBatchUpdateThingsConfigurationRequest,
    ...reqParams.params
  });
}
function thingsThingsDownloadThingsFile(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.infoModelId}/download-things-file`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsGetThingsStatisticInfo(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.infoModelId}/statistic`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsUpdateThingsUsage(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/_updateUsage`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsThingsUpdateConnectionStatus(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/connection-status/${reqParams.connectionStatus}`,
    method: "PUT",
    ...reqParams.params
  });
}
function thingsThingsForceThingsOffline(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/force-offline`,
    method: "PUT",
    ...reqParams.params
  });
}
function thingsThingsLabelQueryList(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/labels`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsLabelDeleteAllLabelsByThingsId(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/labels`,
    method: "DELETE",
    ...reqParams.params
  });
}
function thingsThingsLabelCreate(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/labels/${reqParams.id}/relations`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsMessagesSendMessage(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/messages`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.apiSendMessageRequest,
    ...reqParams.params
  });
}
function thingsStandByMessagesCreateStandByMessage(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/stand-by/message`,
    method: "POST",
    data: reqParams.apiSendMessageRequest,
    ...reqParams.params
  });
}
function thingsStandByMessagesPostStandByMessage(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/stand-by/message`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsUserResourceGetUserListUnderThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/things/${reqParams.thingsId}/things-users`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsBindThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/user/${reqParams.userId}/things/auto-bind`,
    method: "PUT",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsUnbindThings(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/user/${reqParams.userId}/things/auto-bind`,
    method: "DELETE",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsUserResourceAddThingsListByUser(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/users/things`,
    method: "POST",
    params: reqParams.query,
    data: reqParams.addThingsIds,
    ...reqParams.params
  });
}
function thingsUserResourceDeleteThingsListUnderUser(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/users/things`,
    method: "DELETE",
    params: reqParams.query,
    data: reqParams.deleteThingsIds,
    ...reqParams.params
  });
}
function thingsUserResourceDeleteThingsMapUnderUser(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/users/things/map`,
    method: "DELETE",
    params: reqParams.query,
    data: reqParams.request,
    ...reqParams.params
  });
}
function thingsUserResourceGetThingListUnderUser(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/users/${reqParams.userId}/things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsUserResourceUpdateThingListUnderUser(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/users/${reqParams.userId}/things`,
    method: "PUT",
    params: reqParams.query,
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsMessagesQueryDigitalTwinConfigResult(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/users/${reqParams.userId}/things/digital-twin-messages`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsMessagesDigitalTwinSetConfig(reqParams) {
  return fetch({
    url: `/things/tenants/${reqParams.tenantId}/users/${reqParams.userId}/things/digital-twin-messages`,
    method: "POST",
    data: reqParams.body,
    ...reqParams.params
  });
}
function thingsThingsInternalQueryList(reqParams) {
  return fetch({
    url: `/things/things`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsMaintenanceGetSyncChildrenProgress(reqParams) {
  return fetch({
    url: `/things/things/get-sync-children-progress`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsMaintenanceSyncChildren(reqParams) {
  return fetch({
    url: `/things/things/sync-children`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsMaintenanceSyncThingsIndexName(reqParams) {
  return fetch({
    url: `/things/things/sync-things-index-name`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsMaintenanceSyncThingsInfo(reqParams) {
  return fetch({
    url: `/things/things/sync-things-info`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsThingsInfoWithoutTenant(reqParams) {
  return fetch({
    url: `/things/things/${reqParams.thirdThingsId}/things-info`,
    method: "GET",
    params: reqParams.query,
    ...reqParams.params
  });
}
function thingsThingsV2GetThingsList(reqParams) {
  return fetch({
    url: `/things/devices`,
    method: "GET",
    ...reqParams.params
  });
}
function thingsThingsMqttV2GenerateThingsTokensV(reqParams) {
  return fetch({
    url: `/things/mqtt/tokens`,
    method: "POST",
    data: reqParams.apiMqttTokenV2Request,
    ...reqParams.params
  });
}
function thingsThingsMqttV2GenerateThingsLoginByTenantTokensV(reqParams) {
  return fetch({
    url: `/things/mqtt/tokens/login-by-tenant`,
    method: "POST",
    data: reqParams.apiMqttTokenV2Request,
    ...reqParams.params
  });
}

let _http = axios.create({
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/json"
  }
});
function setRequestIntercepter(callback, errorCallback) {
  var _a;
  (_a = _http.interceptors.request) == null ? void 0 : _a.clear();
  _http.interceptors.request.use(callback, errorCallback ? (error) => {
    errorCallback(error);
    return Promise.reject(error);
  } : (error) => {
    return Promise.reject(error);
  });
}
function setResponseIntercepter(callback, errorCallback) {
  var _a;
  (_a = _http.interceptors.response) == null ? void 0 : _a.clear();
  _http.interceptors.response.use(callback ?? ((response) => {
    return response;
  }), errorCallback ? (error) => {
    errorCallback(error);
    return Promise.reject(error);
  } : (error) => {
    var _a2;
    if (window && ((_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.status) === 401) {
      window.location.replace(`${window.location.origin}${window.location.pathname}#/Login`);
    }
    return Promise.reject(error);
  });
}
setResponseIntercepter((response) => {
  return response;
});
setFetch(function({
  url,
  method,
  data,
  params,
  timeout,
  responseType = void 0,
  abortController,
  header
}) {
  if (!header)
    header = generateHttpHeader();
  else
    header = Object.assign(header, generateHttpHeader());
  if (!header.Authorization)
    header.Authorization = generateHttpAuthorization();
  return _http.request({
    url: getBaseUrl() + url,
    method,
    data,
    params,
    timeout: timeout || getGlobalTimeout(),
    responseType,
    headers: header,
    signal: abortController == null ? void 0 : abortController.signal
  }).then((res) => {
    if (responseType) {
      return res;
    }
    return res.data;
  }).catch((error) => {
    let result = {};
    if (axios.isCancel(error)) {
      result = {
        status: "(canceled)",
        errorMsg: error.message
      };
    } else if (error.response) {
      result = {
        status: error.response.status,
        errorMsg: error.response.statusText,
        data: error.response.data
      };
    } else if (error.request) {
      result = {
        status: "NO_RESPONSE",
        errorMsg: "NO_RESPONSE"
      };
    } else {
      result.errorMsg = "Something happened in setting up the request that triggered an Error";
    }
    return Promise.reject(result);
  });
});
setGetStorage((key) => {
  if (localStorage)
    return localStorage.getItem(key);
  else
    return;
});
setSetStorage((key, value) => {
  if (localStorage)
    return localStorage.setItem(key, value);
});
setRemoveStorage((key) => {
  if (localStorage)
    return localStorage.removeItem(key);
});
var index = {};

export { alertMgmtAlertEventsAddOneAlertEvent, alertMgmtAlertEventsBatchHandleEvent, alertMgmtAlertEventsDeleteAlertEvents, alertMgmtAlertEventsDeleteAllAlertEventsUnderTenant, alertMgmtAlertEventsDeleteExpireAlertEvent, alertMgmtAlertEventsDownload, alertMgmtAlertEventsGet, alertMgmtAlertEventsGetAlertEvents, alertMgmtAlertEventsGetOneAlertEvent, alertMgmtAlertEventsHandleEvent, alertMgmtAlertEventsStatisticsStatisticsEventCount, alertMgmtAlertEventsStatisticsStatisticsEventDate, alertMgmtAlertEventsStatisticsStatisticsEvents, alertMgmtEdgeComputingCreateOneEdgeComputingRule, alertMgmtEdgeComputingDeleteEdgeComputingRuleIssuanceHistory, alertMgmtEdgeComputingDeleteOneEdgeComputingRule, alertMgmtEdgeComputingGetEdgeComputingRuleIssuanceHistoryPage, alertMgmtEdgeComputingGetEdgeComputingRulePage, alertMgmtEdgeComputingGetOneEdgeComputingRule, alertMgmtEdgeComputingGetOneEdgeComputingRuleIssuanceHistory, alertMgmtEdgeComputingIssueEdgeComputingRuleToThings, alertMgmtEdgeComputingUpdateOneEdgeComputingRule, alertMgmtHttpActionCreateHttpAction, alertMgmtHttpActionDeleteHttpAction, alertMgmtHttpActionGetHttpActionById, alertMgmtHttpActionGetHttpActionByType, alertMgmtHttpActionQueryHttpActionPage, alertMgmtHttpActionUpdateHttpActionById, alertMgmtManagementCreateKafkaChangelog, alertMgmtManagementSyncAllDigitalTwins2KafkaChangelog, alertMgmtManagementSyncAllRuleActionRecoveryToKafkaChangelog, alertMgmtManagementSyncAllRuleActionToKafkaChangelog, alertMgmtManagementSyncAllTAlertRuleToKafkaChangelog, alertMgmtManagementSyncAllThingsRuleToKafkaChangelog, alertMgmtRuleActionsBuildPayload, alertMgmtRuleActionsCreate, alertMgmtRuleActionsDeleteForwardByIdList, alertMgmtRuleActionsDeleteTriggerByIdList, alertMgmtRuleActionsForwardList, alertMgmtRuleActionsGetOne, alertMgmtRuleActionsListByRule, alertMgmtRuleActionsQuery, alertMgmtRuleActionsRecoveryDeleteTriggerByIdList, alertMgmtRuleActionsRecoveryTriggerCreate, alertMgmtRuleActionsRecoveryTriggerDeleteAction, alertMgmtRuleActionsRecoveryTriggerGetOne, alertMgmtRuleActionsRecoveryTriggerList, alertMgmtRuleActionsRecoveryTriggerUpdateAction, alertMgmtRuleActionsRecoveryTriggerUpdateStatus, alertMgmtRuleActionsThingsForwardDeleteAction, alertMgmtRuleActionsTriggerCreate, alertMgmtRuleActionsTriggerCreate2, alertMgmtRuleActionsTriggerDeleteAction, alertMgmtRuleActionsTriggerGetOne, alertMgmtRuleActionsTriggerList, alertMgmtRuleActionsTriggerUpdateAction, alertMgmtRuleActionsTriggerUpdateStatus, alertMgmtRuleActionsUpdate, alertMgmtRuleActionsUpdateStatus, alertMgmtThingsForwardRulesCreate, alertMgmtThingsForwardRulesDelete, alertMgmtThingsForwardRulesGetAllList, alertMgmtThingsForwardRulesGetOne, alertMgmtThingsForwardRulesGetOneForwardRule, alertMgmtThingsForwardRulesPage, alertMgmtThingsForwardRulesUpdate, alertMgmtThingsForwardRulesUpdateRuleStatus, alertMgmtTriggerRulesBatchUpdateTriggerRules, alertMgmtTriggerRulesCreateTriggerRule, alertMgmtTriggerRulesDeleteTriggerRule, alertMgmtTriggerRulesGetChangedTriggerRules, alertMgmtTriggerRulesGetOneTriggerRuleDetail, alertMgmtTriggerRulesGetRulesTenants, alertMgmtTriggerRulesGetTenantTriggerRules, alertMgmtTriggerRulesGetTriggerRule, alertMgmtTriggerRulesThingsLatestTriggerRule, alertMgmtTriggerRulesUpdateTriggerRule, alertMgmtTriggerRulesUpdateTriggerRuleStatus, alertMgmtTwinsRulesCreateTwinsRule, alertMgmtTwinsRulesDeleteTwinsRule, alertMgmtTwinsRulesGetTenantTwinsRules, alertMgmtTwinsRulesGetTwinsRule, alertMgmtTwinsRulesThingsLatestTwinsRule, alertMgmtTwinsRulesUpdateTwinsRule, alertMgmtTwinsRulesUpdateTwinsRuleStatus, alertMgmtUsageStatisticsGetUsageStatisticsOfAll, alertMgmtUsageStatisticsGetUsageStatisticsOfTenantId, alertMgmtUserResourceGetRuleListUnderUser, alertMgmtUserResourceUpdateRuleListUnderUser, checkPermissionWithApiNames, connectionConnectionControllerCreateConnection, connectionConnectionControllerDeleteConnections, connectionConnectionControllerGetConnection, connectionConnectionControllerQueryConnectionPage, connectionConnectionControllerUpdateConnection, connectionConnectionLabelControllerCreateConnectionLabel, connectionConnectionLabelControllerDeleteConnectionLabels, connectionConnectionLabelControllerQueryConnectionLabel, connectionConnectionLabelControllerQueryConnectionLabels, connectionConnectionTargetControllerCreateTarget, connectionConnectionTargetControllerDeleteTargets, connectionConnectionTargetControllerQueryTarget, connectionConnectionTargetControllerQueryTargets, connectionConnectionTargetControllerUpdateTarget, connectionConnectionTenantControllerCreateConnectionTenantUsingPost, connectionConnectionTenantControllerDeleteConnectionTenantsUsingDelete, connectionConnectionTenantControllerQueryConnectionTenantsUsingGet, connectionThingsMessageControllerGetMessage, connectionThingsMessageControllerGetMessageStatistics, controlClientTokenCreateClientToken, controlMyPrivilegeGetMyPrivileges, controlOrganizationBind, controlOrganizationCreate, controlOrganizationDelete, controlOrganizationGetList, controlOrganizationGetOrganizationTree, controlOrganizationGetOrganizationUserPageInfo, controlOrganizationUnbind, controlOrganizationUpdate, controlSecretCreate, controlSecretDelete, controlSecretGetByPage, controlSecretUpdate, controlSessionCreateSession, controlSessionCreateSessionTenantManager, controlSessionGetSession, controlSessionGetSuperSession, controlSessionRefreshSession, controlSessionRemoveSession, controlSessionV2CreateSessionV, controlSessionV2DeleteSessionV, controlTenantAPIGetTenantApiPage, controlTenantRoleCreateOneTenantRole, controlTenantRoleCreateRoleMenu, controlTenantRoleDeleteRoleMenu, controlTenantRoleDeleteTenantRoles, controlTenantRoleGetCommonRolePage, controlTenantRoleGetOneTenantRole, controlTenantRoleGetRoleMenu, controlTenantRoleGetTenantRolePage, controlTenantRoleMergeCopyRoles, controlTenantRoleRefreshDataUsingGet, controlTenantRoleUpdateApIsOfOneTenantRole, controlTenantRoleUpdateOneTenantRole, controlTenantRoleUpdateRoleMenu, controlThirdLoginBindForSession, controlThirdLoginCheckForSession, controlUserPrivilegeCancelTenantUserRoles, controlUserPrivilegeCreateTenantUsersWithRoles, controlUserPrivilegeDeleteUserMenus, controlUserPrivilegeGetMenuListOfTenantUser, controlUserPrivilegeGetRoleListOfTenantUser, controlUserPrivilegeUpdateTenantUserMenus, controlUserPrivilegeUpdateTenantUserRoles, controlUserPrivilegeUpdateTenantUsersWithRoles, controlUsercenterGetThirdSupport, controlUsercenterGetVerificationCode, dataMgmtCustomDataDownloadTemplateCreateTemplate, dataMgmtCustomDataDownloadTemplateDeleteTemplate, dataMgmtCustomDataDownloadTemplateGetTemplateDetail, dataMgmtCustomDataDownloadTemplateGetTemplateDetailByInfoModel, dataMgmtCustomDataDownloadTemplateUpdateTemplate, dataMgmtDashboardControllerAddDashboardPanelMetricUsingPost, dataMgmtDashboardControllerAddDashboardPanelUsingPost, dataMgmtDashboardControllerAddDashboardUsingPost, dataMgmtDashboardControllerDelDashboardPanelMetricUsingDelete, dataMgmtDashboardControllerDeleteDashboardPanelMetricUsingDelete, dataMgmtDashboardControllerDeleteDashboardPanelUsingDelete, dataMgmtDashboardControllerDeleteDashboardUsingDelete, dataMgmtDashboardControllerGetDashboardPanelUsingGet, dataMgmtDashboardControllerGetDashboardUsingGet, dataMgmtDashboardControllerListDashboardPanelMetricUsingGet, dataMgmtDashboardControllerListDashboardPanelUsingGet, dataMgmtDashboardControllerListDashboardUsingGet, dataMgmtDashboardControllerUpdDashboardPanelMetricUsingPut, dataMgmtDashboardControllerUpdateDashboardPanelUsingPut, dataMgmtDashboardControllerUpdateDashboardUsingPut, dataMgmtDataCleaningCleanAllThingsData, dataMgmtDataCleaningCleanDataByBatchQuery, dataMgmtDataCleaningCleanDataByTenant, dataMgmtDataCleaningCleanDataByThings, dataMgmtDataCleaningCreateQuickDeleteTask, dataMgmtDataCleaningCreateSingleIndex, dataMgmtDataCleaningCurrentCleanTask, dataMgmtDataCleaningExecuteQuickDeleteTask, dataMgmtDataCleaningQuickDeleteTaskList, dataMgmtDataCleaningSetCleanSpeed, dataMgmtDataCleaningTaskDocumentRemaining, dataMgmtDataCleaningTodoCleanTaskList, dataMgmtDataTransformCreate, dataMgmtDataTransformDeleteOne, dataMgmtDataTransformGetOne, dataMgmtDataTransformListQuery, dataMgmtDataTransformPageQuery, dataMgmtDataTransformTestScript, dataMgmtDataTransformUpdate, dataMgmtDataTransformUpdateStatus, dataMgmtElasticsearchMappingMatchMappingPropertyType, dataMgmtElasticsearchTemplateDelete, dataMgmtElasticsearchTemplateGet, dataMgmtElasticsearchTemplateSave, dataMgmtJobHandlerJobHandlerCancelQuickDeleteTaskGet, dataMgmtJobHandlerJobHandlerCheckDeleteDataSendSmsGet, dataMgmtJobHandlerJobHandlerClearIndexTaskGet, dataMgmtJobHandlerJobHandlerDeleteOssFileGet, dataMgmtJobHandlerJobHandlerEndTaskGet, dataMgmtJobHandlerJobHandlerQuickDeleteTaskGet, dataMgmtJobHandlerJobHandlerStatisticsTaskCronGet, dataMgmtJobHandlerJobHandlerStatisticsTaskGet, dataMgmtJobHandlerJobHandlerStatisticsUsageOnTimeGet, dataMgmtJobHandlerJobHandlerStatisticsUsageSummaryGet, dataMgmtMessageBatchQueryResponse, dataMgmtOpLogQueryOpLogRecords, dataMgmtStatisticSyncStatistics, dataMgmtStatisticsAggregateCommonStatistic, dataMgmtStatisticsExportTransformCreate, dataMgmtStatisticsExportTransformDeleteOne, dataMgmtStatisticsExportTransformGetOne, dataMgmtStatisticsExportTransformListQuery, dataMgmtStatisticsExportTransformUpdate, dataMgmtStatisticsExportTransformUpdateStatus, dataMgmtStatisticsHistory, dataMgmtStatisticsMethodsCreate, dataMgmtStatisticsMethodsDelete, dataMgmtStatisticsMethodsGet, dataMgmtStatisticsMethodsGetParamFields, dataMgmtStatisticsMethodsPage, dataMgmtStatisticsMethodsUpdate, dataMgmtStatisticsOriginHistory, dataMgmtStatisticsOriginTenant, dataMgmtStatisticsOriginThings, dataMgmtStatisticsOriginThingsInternal, dataMgmtStatisticsSearchCommonStatistic, dataMgmtStatisticsTaskCreate, dataMgmtStatisticsTaskCreateStatisticsTimerTaskUsingPost, dataMgmtStatisticsTaskDelete, dataMgmtStatisticsTaskExecute, dataMgmtStatisticsTaskGet, dataMgmtStatisticsTaskJrnlAggData, dataMgmtStatisticsTaskJrnlAggDataByTime, dataMgmtStatisticsTaskJrnlCreateAggDataDownloadRecord, dataMgmtStatisticsTaskJrnlCreateStatisticsDataDownloadRecordUsingPost, dataMgmtStatisticsTaskJrnlGetStatisticsDataDownloadRecordUsingGet, dataMgmtStatisticsTaskJrnlPage, dataMgmtStatisticsTaskJrnlPageByDimension, dataMgmtStatisticsTaskPage, dataMgmtStatisticsTaskUpdate, dataMgmtStatisticsTaskUpdateBatchByIds, dataMgmtStatisticsTaskUpdateStatisticsTimerTaskUsingPut, dataMgmtStatisticsTaskUpdateStatus, dataMgmtStatisticsTenant, dataMgmtStatisticsThings, dataMgmtStatisticsThingsUsage, dataMgmtTenantUsageCalculateUsageOnTime, dataMgmtTenantUsageEndTaskJrnl, dataMgmtTenantUsageLatest, dataMgmtTenantUsagePercentage, dataMgmtTenantUsageUsageList, dataMgmtTestControllerAsyncSearchUsingGet, dataMgmtTestControllerEsAsyncSearchUsingGet, dataMgmtTestControllerGetCodeVersionUsingGet, dataMgmtTestControllerGetServicePackageLimitUsingGet, dataMgmtTestControllerSendSageExcessEmailUsingGet, dataMgmtTestControllerTestDeleteUsingGet, dataMgmtThingsDataAggregationsThingsDataByEventUsingGet, dataMgmtThingsDataAggregationsThingsDataUsingGet, dataMgmtThingsDataBatchListThingsDataUsingGet, dataMgmtThingsDataCreateSpecialThingsDataDownloadRecordUsingPost, dataMgmtThingsDataCreateThingsData, dataMgmtThingsDataCreateThingsDataDownloadRecordByBatchQueryUsingPost, dataMgmtThingsDataCreateThingsDataDownloadRecordUsingPost, dataMgmtThingsDataDeleteSpecialStorageIndexUsingDelete, dataMgmtThingsDataGetGpsHistoryDataByBatchQueryUsingPost, dataMgmtThingsDataGetGpsHistoryDataUsingPost, dataMgmtThingsDataGetHistoryDataAggregationUsingPost, dataMgmtThingsDataGetMultiThingsDataUsingPost, dataMgmtThingsDataGetSignalPeriodUsingPost, dataMgmtThingsDataGetSpecialStorageIndexListUsingGet, dataMgmtThingsDataGetThingsDataDownloadRecordUsingGet, dataMgmtThingsDataGetThingsDataDownloadingRecordListUsingGet, dataMgmtThingsDataGetThingsMessageTraceDataUsingGet, dataMgmtThingsDataHandleThingsLogUsingPost, dataMgmtThingsDataListThingsDataByBatchQueryUsingPost, dataMgmtThingsDataListThingsDataUsingGet, dataMgmtThingsDataListThingsDataUsingPost, dataMgmtThingsDataQueryThingsDataByGroupUsingGet, dataMgmtThingsDataQueryThingsDataByGroupWithMultiConditionUsingPost, dataMgmtThingsDataReexportUsingPost, dataMgmtThingsDataUpdateThingsDataDownloadRecordStatusUsingPut, dataMgmtUsageStatisticsGetUsageStatisticsByTenantIdList, dataMgmtUsageStatisticsGetUsageStatisticsByTenantIdListAndSort, dataMgmtUsageStatisticsGetUsageStatisticsOfAll, dataMgmtUserResourceGetDashboardListUnderUser, dataMgmtUserResourceUpdateDashboardListUnderUser, index as default, fetch, generateHttpAuthorization, generateHttpHeader, getBaseUrl, getGlobalTimeout, getStorageCallback, hasPermission, init, jobMgmtHandlerActionCreateHandlerAction, jobMgmtHandlerActionDeleteHandlerAction, jobMgmtHandlerActionGetHandlerAction, jobMgmtHandlerActionQueryHandlerAction, jobMgmtHandlerActionQueryHandlerActionPage, jobMgmtHandlerActionUpdateHandlerAction, jobMgmtJobCreateJob, jobMgmtJobDeleteJob, jobMgmtJobGetJob, jobMgmtJobLogBatchDeleteJobLog, jobMgmtJobLogCleanupJobLog, jobMgmtJobLogDeleteJobLog, jobMgmtJobLogQueryJobLog, jobMgmtJobManualExecuteJob, jobMgmtJobQueryJob, jobMgmtJobResultCreate, jobMgmtJobResultDelete, jobMgmtJobResultQueryByJobId, jobMgmtJobResultQueryOne, jobMgmtJobResultQueryPage, jobMgmtJobResultUpdate, jobMgmtJobUpdateJob, jobMgmtJobUpdateJobStatus, jobMgmtOauth2TestTestGetMethod, mappingMappingGetCloneSimple, mappingMappingGetDetailInfo, mappingMappingValidateBuildData, mappingMappingValidateParseData, mappingMgmtCategoryCreate, mappingMgmtCategoryDelete, mappingMgmtCategoryGetOne, mappingMgmtCategoryGetOneByInfoModelId, mappingMgmtCategoryQueryList, mappingMgmtCategoryTemplateExportGlobal, mappingMgmtCategoryTemplateExportOne, mappingMgmtCategoryTemplateGetGlobal, mappingMgmtCategoryTemplateGetOne, mappingMgmtCategoryTemplateUpdateGlobal, mappingMgmtCategoryTemplateUpdateOne, mappingMgmtCategoryUpdate, mappingMgmtDbcCreateInfoModel4All, mappingMgmtDbcDbcMessageConfigs, mappingMgmtDbcDeleteDbc, mappingMgmtDbcGetList, mappingMgmtDbcGetOne, mappingMgmtDbcUpdateDbcFile, mappingMgmtDbcUpdateInfoModel4All, mappingMgmtDbcUploadDbcFile, mappingMgmtInfoModelMappingCreate, mappingMgmtInfoModelMappingCreateMappingWithItem, mappingMgmtInfoModelMappingDelete, mappingMgmtInfoModelMappingGetOne, mappingMgmtIotEntityCreate, mappingMgmtIotEntityDelete, mappingMgmtIotEntityGetList, mappingMgmtIotEntityGetList4Public, mappingMgmtIotEntityGetOne, mappingMgmtIotEntityUpdate, mappingMgmtIotFunctionBlockBatchDeleteSchemaProperties, mappingMgmtIotFunctionBlockBatchUpdateSchema, mappingMgmtIotFunctionBlockCreate, mappingMgmtIotFunctionBlockDelete, mappingMgmtIotFunctionBlockDeleteSchemaProperties, mappingMgmtIotFunctionBlockExportFile, mappingMgmtIotFunctionBlockGetImportProgress, mappingMgmtIotFunctionBlockGetList, mappingMgmtIotFunctionBlockGetListByList, mappingMgmtIotFunctionBlockGetOne, mappingMgmtIotFunctionBlockGetSchemaProperties, mappingMgmtIotFunctionBlockImportFile, mappingMgmtIotFunctionBlockPatchSchemaProperties, mappingMgmtIotFunctionBlockUpdateFunctionBlock, mappingMgmtIotFunctionBlockUpdateSchemaProperties, mappingMgmtIotInfoModelCleanAllInfoModelByTenant, mappingMgmtIotInfoModelCreate, mappingMgmtIotInfoModelDelete, mappingMgmtIotInfoModelGetInfoModel, mappingMgmtIotInfoModelGetInfoModelByIds, mappingMgmtIotInfoModelGetInfoModelByNames, mappingMgmtIotInfoModelGetInfoModelCommon, mappingMgmtIotInfoModelGetInfoModelIdsByPackageItemValue, mappingMgmtIotInfoModelGetInfoModelInternal, mappingMgmtIotInfoModelGetInfoModelInternalPwd, mappingMgmtIotInfoModelGetInfoModelPwd, mappingMgmtIotInfoModelGetInfoModelPwdByIds, mappingMgmtIotInfoModelGetInfoModelTimeoutMap, mappingMgmtIotInfoModelGetList, mappingMgmtIotInfoModelGetList4All, mappingMgmtIotInfoModelGetList4Public, mappingMgmtIotInfoModelGetTenantInfoModelByNames, mappingMgmtIotInfoModelLabelCreate, mappingMgmtIotInfoModelLabelDelete, mappingMgmtIotInfoModelLabelGetFuzzyList, mappingMgmtIotInfoModelLabelGetList, mappingMgmtIotInfoModelPaddingConfiguration, mappingMgmtIotInfoModelSavePublicInfoModelToTenant, mappingMgmtIotInfoModelUpdate, mappingMgmtIotInfoModelUpdatePwd, mappingMgmtIotInfoModelValidateConfiguration, mappingMgmtMappingRuleInfoBatchCreate, mappingMgmtMappingRuleInfoCreate, mappingMgmtMappingRuleInfoDelete, mappingMgmtMappingRuleInfoGetByName, mappingMgmtMappingRuleInfoGetList, mappingMgmtMappingRuleInfoGetOne, mappingMgmtMappingRuleInfoUpdate, mappingMgmtRelocationExportInfoModel, mappingMgmtRelocationExportInfoModelFile, mappingMgmtRelocationImportInfoModel, mappingMgmtRelocationImportInfoModelFile, mappingMgmtSyncToChangelogSyncAllDbc, mappingMgmtSyncToChangelogSyncAllInfoModelDetail, mappingMgmtSyncToChangelogSyncOneDbc, mappingMgmtSyncToChangelogSyncOneInfoModelDetail, mappingMgmtUserResourceAddInfoModelListByUser, mappingMgmtUserResourceDeleteInfoModelListUnderUser, mappingMgmtUserResourceGetInfoModelListUnderUser, mappingMgmtUserResourceUpdateInfoModelListUnderUser, mappingTempDataGetAlertRule, mappingTempDataGetFragmentInfo, mappingTempDataGetThingsIndexNameMap, mappingTempDataGetThingsLabelInfo, notificationMailAsyncSend, notificationMailSend, notificationMessageQueryAllMessages, notificationMessageQueryMyMessages, notificationMessageReadMessages, notificationMessageReadMyAllMessages, notificationPushLogsDeletePushLogs, notificationPushLogsQueryPushLogs, notificationRuleActionCheckRuleActionConfig, notificationRuleActionCheckRuleActionScript, notificationSMSAsyncSend, notificationSMSSend, notificationSMSSmsPage, notificationSMSTenantAsyncSend, notificationSMSTenantSend, notificationTestTestCallUsingPost, notificationTestTestKafkaUsingGet, notificationTestTestMailUsingGet, notificationTestTestSaveTriggerRecordUsingGet, notificationTestTestSmsUsingGet, notificationTestTestZlgHttpActionUsingGet, notificationVMSAsyncSendVms, notificationVMSSendVms, notificationVMSTenantAsyncSendVms, notificationVMSTenantSendVms, notificationVMSVmsPage, optionComponentOptionTestUploadUsingPost, outFilemanagerComponentCallList, outFilemanagerComponentCategoryCategoryList, outFilemanagerComponentCategoryCreateCategory, outFilemanagerComponentCategoryDeleteCategory, outFilemanagerComponentCategoryGetCategoryOrder, outFilemanagerComponentCategoryMoveCategoryOrder, outFilemanagerComponentCategoryUpdateCategory, outFilemanagerComponentCreate, outFilemanagerComponentDelete, outFilemanagerComponentGetComponentStatistics, outFilemanagerComponentGetComponentStatisticsSort, outFilemanagerComponentGetWebStatistics, outFilemanagerComponentInteriorDelete, outFilemanagerComponentInteriorList, outFilemanagerComponentListStatic, outFilemanagerComponentOptionCreateComponentOption, outFilemanagerComponentOptionDeleteComponentOption, outFilemanagerComponentOptionDeleteDownloadOption, outFilemanagerComponentOptionDownloadOption, outFilemanagerComponentOptionDownloadOptionByIdentifier, outFilemanagerComponentOptionGetComponentOption, outFilemanagerComponentOptionGetComponentOptionByResource, outFilemanagerComponentOptionGetComponentOptionDetail, outFilemanagerComponentOptionGetComponentOptionOrder, outFilemanagerComponentOptionGetDownloadOptionInfo, outFilemanagerComponentOptionGetDownloadOptionInfoByIdentifier, outFilemanagerComponentOptionMoveComponentOption, outFilemanagerComponentOptionUpdateComponentOption, outFilemanagerComponentTriggerComponentStatistics, outFilemanagerComponentUpdate, outFilemanagerFileCleanFiles, outFilemanagerFileDeleteFile, outFilemanagerFileDeviceUploadFilePart, outFilemanagerFileDownloadFile, outFilemanagerFileGetFile, outFilemanagerFileListFiles, outFilemanagerFileUploadFile, outFilemanagerFileUploadFilePart, outFilemanagerFileV2DeviceUploadFileV, outFilemanagerFileV2GetUploadFileV, outFilemanagerJobHandlerCleanOssFile, outFilemanagerPackageGetAllPackages, outFilemanagerPackageGetLastPackage, outFilemanagerPackageGetPackage, outFilemanagerPackageRemovePackage, outFilemanagerPackageUploadPackage, outFilemanagerPackageV2GetAllPackagesV, outFilemanagerPackageV2GetLastPackageV, outFilemanagerPackageV2GetPackageV, outFilemanagerPackageV2RemovePackageV, outFilemanagerPackageV2UploadPackageV, outFilemanagerPlanClearLogs, outFilemanagerPlanCreatePlan, outFilemanagerPlanDeletePlan, outFilemanagerPlanListLogs, outFilemanagerPlanListPlans, outFirmwareMgmtDownloadGetDownloadUrl, outFirmwareMgmtFirmwareDelete, outFirmwareMgmtFirmwareGetFirmwareDesc, outFirmwareMgmtFirmwareGetNewestFirmware, outFirmwareMgmtFirmwareGetNewestFirmwareBatch, outFirmwareMgmtFirmwareListFirmware, outFirmwareMgmtFirmwareNotifyUpgrade, outFirmwareMgmtFirmwareNotifyUpgradeBatch, outFirmwareMgmtFirmwareUpdateFirmwarePublicState, outFirmwareMgmtFirmwareUploadFirmware, outFirmwareMgmtUpgradeCreateUpgradeTask, outFirmwareMgmtUpgradeDeleteUpgrade, outFirmwareMgmtUpgradeEndUpgrade, outFirmwareMgmtUpgradeQueryUpgradeTaskList, outFirmwareMgmtUpgradeQueryUpgradeThings, outFirmwareMgmtUpgradeQueryUpgradeThingsStatistic, outFirmwareMgmtUpgradeRefreshUpgrade, outFirmwareMgmtUpgradeStartUpgrade, outFirmwareMgmtUpgradeStopUpgrade, outGroupMgmtDeviceBindDeviceToGroup, outGroupMgmtDeviceBindDeviceToGroupWithInfo, outGroupMgmtDeviceGetDeviceListFromGroupWithoutPage, outGroupMgmtDeviceRetrieveDevicesFromGroup, outGroupMgmtDeviceSendCommandToDevice, outGroupMgmtDeviceUnbindDeviceFromGroup, outGroupMgmtDeviceUpdateExtraInfo, outGroupMgmtGroupCountCreateConfig, outGroupMgmtGroupCountDoCountDataNow, outGroupMgmtGroupCountQueryConfigPage, outGroupMgmtGroupCountQueryOneConfig, outGroupMgmtGroupCountUpdateConfig, outGroupMgmtGroupCreateGroup, outGroupMgmtGroupDeleteGroup, outGroupMgmtGroupInternalQueryList, outGroupMgmtGroupManagerDeleteAllGroups, outGroupMgmtGroupManagerUnbindAllDevicesFromGroup, outGroupMgmtGroupPlusOnlineStatus, outGroupMgmtGroupPlusRetrieveGroup, outGroupMgmtGroupPlusRetrieveGroupList, outGroupMgmtGroupPlusUpdateStatus, outGroupMgmtGroupPriceCreate, outGroupMgmtGroupPriceCreateTemplate, outGroupMgmtGroupPriceDelete, outGroupMgmtGroupPriceDeleteTemplate, outGroupMgmtGroupPriceGetGroupPricePresuppose, outGroupMgmtGroupPriceQueryOne, outGroupMgmtGroupPriceQueryOneTemplate, outGroupMgmtGroupPriceQueryPage, outGroupMgmtGroupPriceQueryTemplatePage, outGroupMgmtGroupPriceUpdate, outGroupMgmtGroupPriceUpdateGroupPricePresuppose, outGroupMgmtGroupPriceUpdateTemplate, outGroupMgmtGroupQueryGroupInternal, outGroupMgmtGroupRetrieveGroup, outGroupMgmtGroupRetrieveGroupList, outGroupMgmtGroupRetrieveGroupListByDeviceIds, outGroupMgmtGroupRetrieveGroupListByDeviceIdsWithOrder, outGroupMgmtGroupRetrieveGroupListByIds, outGroupMgmtGroupStatisticsCountGroupField, outGroupMgmtGroupStatisticsCountGroupTopData, outGroupMgmtGroupStatisticsCountGroupValueCount, outGroupMgmtGroupStrategyCreate, outGroupMgmtGroupStrategyCreateTemplate, outGroupMgmtGroupStrategyDelete, outGroupMgmtGroupStrategyDeleteTemplate, outGroupMgmtGroupStrategyQueryList, outGroupMgmtGroupStrategyQueryOneTemplate, outGroupMgmtGroupStrategyQueryTemplatePage, outGroupMgmtGroupStrategyUpdate, outGroupMgmtGroupStrategyUpdateTemplate, outGroupMgmtGroupUpdateGroup, outGroupMgmtInternalBatchQueryGroupThingsMap, outGroupMgmtInternalRetrieveAllDevicesUnderGroup, outGroupMgmtInternalRetrieveAllDevicesUnderUser, outGroupMgmtInternalRetrieveGroupListByThingsId, outGroupMgmtInternalRetrieveGroupListByThirdThingsId, outGroupMgmtJobHandlerOutGroupMgmtJobHandlerGroupCountGet, outGroupMgmtProjectCreate, outGroupMgmtProjectDeleteProject, outGroupMgmtProjectGetProject, outGroupMgmtProjectGetProjects, outGroupMgmtProjectResourceCreateResource, outGroupMgmtProjectResourceCreateResourceBatch, outGroupMgmtProjectResourceDeleteResource, outGroupMgmtProjectResourceGetResources, outGroupMgmtProjectResourceGetResourcesBatch, outGroupMgmtProjectResourceUpdateResourceBatch, outGroupMgmtProjectUpdateProject, outGroupMgmtUserResourceCreateGroupUserBind, outGroupMgmtUserResourceGetBindUserListUnderGroup, outGroupMgmtUserResourceGetBindUserListWithoutPage, outGroupMgmtUserResourceGetGroupListUnderUser, outGroupMgmtUserResourceGetUnbindUserListUnderGroup, outGroupMgmtUserResourceUpdateGroupListUnderUser, outGroupMgmtUserResourceUserCollectGroup, outGroupMgmtUserResourceUserGroupAuth, outGroupMgmtUserResourceUserUnCollectGroup, outGroupMgmtUserResourceUserUnbindGroup, outHmiDomainCreateDomain, outHmiDomainDeleteDomain, outHmiDomainRetrieveDomain, outHmiDomainRetrieveDomainList, outHmiDomainUpdateDomain, outHmiFlowCreateFlow, outHmiFlowDeleteFlow, outHmiFlowRetrieveFlow, outHmiFlowRetrieveFlowApi, outHmiFlowRetrieveFlowList, outHmiFlowRetrieveFlowState, outHmiFlowUpdateFlow, outHmiFlowValidateFlow, outHmiHMICreateHmi, outHmiHMIDeleteHmi, outHmiHMIRetrieveHmi, outHmiHMIRetrieveHmiList, outHmiHMIRetrieveHmiListByRoot, outHmiHMIRetrieveHmiListUnderManager, outHmiHMIUpdateHmi, outHmiSessionCreateHmiSession, outHmiSessionGetSession, outHmiTemplateCreateTemplate, outHmiTemplateDeleteTemplate, outHmiTemplateDeleteTemplateCategory, outHmiTemplateGetTemplateCategoryList, outHmiTemplateGetTemplateCategoryOrder, outHmiTemplateGetTemplateList, outHmiTemplatePostTemplateCategory, outHmiTemplateUpdateTemplate, outHmiTemplateUpdateTemplateCategory, outHmiTemplateUpdateTemplateCategoryOrder, outHmiUserResourceGetUserResource, outHmiUserResourceGetUserResourceTree, outHmiUserResourceRetrieveFlowListUnderUser, outHmiUserResourceRetrieveWebListUnderUser, outHmiUserResourceUpdateFlowListUnderUser, outHmiUserResourceUpdateUserResource, outHmiUserResourceUpdateWebListUnderUser, outHmiWebCreateWeb, outHmiWebDeleteWeb, outHmiWebGetWebRelease, outHmiWebRetrieveReleaseWeb, outHmiWebRetrieveWeb, outHmiWebRetrieveWebInfo, outHmiWebRetrieveWebList, outHmiWebRetrieveWebListByRoot, outHmiWebUpdateReleaseStatus, outHmiWebUpdateWeb, outHmiWebUploadWebModel, outWebConfigConfigInfo, outWebConfigConfigSave, outWebDeployWebInfo, outWebDeployWebList, outWebDeployWebRelease, outWebDeployWebRemove, outWebDeployWebSave, outWebLicenceAddLicenceSecret, outWebLicenceDeleteLicenceSecretInfo, outWebLicenceGenerationThingsLicense, outWebLicenceGetLicenceConfig, outWebLicenceGetLicenceSecretInfo, outWebLicenceGetLicenceSecretList, outWebLicenceUpdateLicenceConfig, outWebLicenceUpdateLicenceSecretInfo, outWebLogLogList, outWebLogServiceLogDetail, outWebLogServiceLogList, outWebNoticeCreate, outWebNoticeDelete, outWebNoticeGetListByPage, outWebNoticeGetOne, outWebNoticeGetUserNotice, outWebNoticeGetUserNoticeConfig, outWebNoticeUpdate, outWebNoticeUpdateUserNoticeConfig, outWebServerConfigAddServiceAdjustStrategy, outWebServerConfigDeleteServiceAdjustStrategy, outWebServerConfigGetServiceAdjustStrategyList, outWebServerConfigGetServiceConfig, outWebServerConfigUpdateServiceAdjustStrategy, outWebServerConfigUpdateServiceConfig, outWebServerConfigUpdateServiceReplicas, outWebSystemValidityPeriodGetSystemValidityPeriod, outWebSystemValidityPeriodSaveSystemValidityPeriod, outWebThingsActiveGetThingsActiveList, outWebThingsActiveGetThingsActiveStatistic, outWebUserActiveGetUserActiveList, outWebUserActiveGetUserActiveStatistic, outWrapperAdminStatisticsThingsOrigin, outWrapperBehaviorCreateBehavior, outWrapperBehaviorGetBehavior, outWrapperBehaviorSortByAction, outWrapperBehaviorSortByModule, outWrapperBehaviorSortByTenant, outWrapperCandtuCreateCandtuStatisticsDataDownloadRecord, outWrapperCandtuGetCandtuReportSummaryResultList, outWrapperCandtuGetCarInfoDataList, outWrapperCandtuGetVehicleStatusStatistic, outWrapperCommandTemplateCreate, outWrapperCommandTemplateDelete, outWrapperCommandTemplateGetOne, outWrapperCommandTemplateGetTemplateList, outWrapperCommandTemplateUpdate, outWrapperGroupBatchPostMessage, outWrapperGroupBindDeviceToGroupWithInfo, outWrapperGroupCountGroupOnline, outWrapperGroupCreateSummaryStatisticsDataDownloadRecord, outWrapperGroupDownloadGroupAlertEvent, outWrapperGroupGetAlertEvents, outWrapperGroupGetGroupCountById, outWrapperGroupGetGroupCountByIdIndustryEs, outWrapperGroupGetGroupCountInfo, outWrapperGroupGetGroupCountInfoIndustryEs, outWrapperGroupGetGroupCountList, outWrapperGroupGetGroupCountRecentWeek, outWrapperGroupGetGroupCountRecentWeekIndustryEs, outWrapperGroupGetGroupCountRecentWeekIndustryEsSy, outWrapperGroupGetGroupCountRecentYear, outWrapperGroupGetGroupEfficiency, outWrapperGroupGetGroupIndustryEsIncomePrediction, outWrapperGroupGetRecalculationTask, outWrapperGroupGetReportSummaryResultList, outWrapperGroupGetTopGroups, outWrapperGroupGetTopGroupsIndustryEs, outWrapperGroupQueryThingsList, outWrapperGroupQueryThingsListWithoutPage, outWrapperGroupRecalculate, outWrapperGroupStatistics, outWrapperGroupUpdateGroupDeviceExtraInfo, outWrapperIndustryESGetStationInfo, outWrapperIndustryESQueryBmsBcuDataInfo, outWrapperIndustryESQueryBmsBcuMapping, outWrapperIndustryESQueryChargeInfo, outWrapperIndustryESQueryCountInfo, outWrapperIndustryESQueryDeviceDataInfo, outWrapperIndustryESQueryDeviceOneInfo, outWrapperIndustryESQueryDevicesInfo, outWrapperIndustryESQueryEnergyInfo, outWrapperIndustryESQueryFnDataGroupDisplay, outWrapperIndustryESQueryGroupVideoMonitorConfig, outWrapperIndustryESQueryIncomeInfo, outWrapperIndustryESQueryRunningInfo, outWrapperIndustryESQueryWarningCount, outWrapperIndustryESQueryWarningInfo, outWrapperMessagesGetCurrentSystemTimestamp, outWrapperMessagesQueryBlockMessageResponse, outWrapperMessagesSendBlockMessage, outWrapperMessagesSendSyncMessage, outWrapperRepairCreateRepair, outWrapperRepairDeleteOne, outWrapperRepairGetOne, outWrapperRepairHandleRepair, outWrapperRepairQueryRepairPage, outWrapperScreenGetAlertStatistic, outWrapperScreenGetDeviceOnlineStatistic, outWrapperScreenGetInfoModelStatistic, outWrapperStatisticGetRecentSystemTpsStatistic, outWrapperTenantsGetTenantSpecialPrivilege, outWrapperTenantsQuerySpecialPrivilegePage, outWrapperTenantsQueryTenantPage, outWrapperTenantsUpdateTenantSpecialPrivilege, outWrapperThingsBatchRegisterThings, outWrapperThingsQueryBatchById, outWrapperThingsQueryList, outWrapperThingsQueryOne, outWrapperThingsRegisterThings, outWrapperThingsStatisticsThingsModelThings, outWrapperThingsV2RegisterThings, outWrapperTunnelCreateDeviceTunnel, outWrapperTunnelDeleteDeviceTunnel, outWrapperTunnelListDeviceTunnels, outWrapperTunnelUpdateDeviceTunnel, outWrapperUtilsCalibrationTimestamp, outWrapperUtilsCellocationCell, outWrapperUtilsCellocationWifi, outWrapperVideoManageAddVideos, outWrapperVideoManageDeleteVideos, outWrapperVideoManageQueryVideos, outWrapperVideoManageUpdateVideos, outWrapperWorkCreateWork, outWrapperWorkDeleteOne, outWrapperWorkGetOne, outWrapperWorkHandleWork, outWrapperWorkQueryWorkPage, registerErrorCode, removeRoles, removeStorageCallback, setBaseUrl, setErrorCodeList, setErrorHandler, setFetch, setFetchLocale, setFetchToken, setGetStorage, setGlobalTimeout, setRemoveStorage, setRequestIntercepter, setResponseIntercepter, setRoles, setSetStorage, setStorageCallback, singleAnalysisScriptAddAnalysisScript, singleAnalysisScriptDeleteAnalysisScript, singleAnalysisScriptGetAnalysisScriptById, singleAnalysisScriptGetAnalysisScriptList, singleAnalysisScriptUpdateAnalysisScript, singleBindingAddEcuBinding, singleCarInfoAddCarInfo, singleCarInfoDeleteCarInfo, singleCarInfoGetCarInfo, singleCarInfoGetCarInfoList, singleCarInfoGetCarInfoListInternal, singleCarInfoUpdateCarInfo, singleCompatCreateSessionV, singleCompatDeleteSessionV, singleCompatDeviceUploadFileV, singleCompatGenerateThingsTokensV, singleCompatGetAllPackagesV, singleCompatGetLastPackageV, singleCompatGetPackageV, singleCompatGetThingsList, singleCompatGetUploadFileV, singleCompatRegisterThings, singleCompatRemovePackageV, singleCompatUploadPackageV, singleDbcAddDbcChannelBind, singleDbcDeleteDbcChannelBind, singleDbcGetDbcChannelBind, singleDbcGetDbcChannelBindList, singleDbcSyncAllIndexToKafka, singleDbcUpdateDbcChannelBind, singleDtcDeleteDtcContents, singleDtcGetDtcContents, singleDtcGetDtcFileList, singleDtcGetDtcFileTemplate, singleDtcGetDtcShowCode, singleDtcUpdateDtcContents, singleDtcUploadDtcContents, singleEcuAddEcuConfiguration, singleEcuDeleteEcuConfiguration, singleEcuGetEcuConfiguration, singleEcuGetEcuConfigurationList, singleEcuGetFileUrl, singleEcuUpdateEcuConfiguration, singleEcuUploadFile, singleFenceAddFence, singleFenceDeleteFence, singleFenceGetFenceDetail, singleFenceGetFencePage, singleFenceUpdateFence, singleFunctionBlockImportFunctionBlockFromFile, singleLorawanAddMulticastGroupDevice, singleLorawanCommandLorawanThings, singleLorawanCreateMulticastGroup, singleLorawanInfoMulticastGroups, singleLorawanListMulticastGroup, singleLorawanListMulticastGroupDevices, singleLorawanMessageMulticastGroup, singleLorawanRegisterLorawanThings, singleLorawanRemoveMulticastGroupDevice, singleLorawanRemoveMulticastGroups, singleLorawanUpdateMulticastGroup, singleTestProcessAddTestProcess, singleTestProcessDeleteTestProcess, singleTestProcessExecuteTestProcess, singleTestProcessGetAnalysisReport, singleTestProcessGetCurrentTestProcessTask, singleTestProcessGetExecuteRecord, singleTestProcessGetTestProcessById, singleTestProcessGetTestProcessList, singleTestProcessUpadteExecuteRecordStatus, singleTestProcessUpdateTestProcess, singleThingsFileCleanThingsFileStorage, singleThingsFileDeleteThingsFile, singleThingsFileGetDownloadUrls, singleThingsFileGetFileUploadParameter, singleThingsFileGetThingsFileCapacity, singleThingsFileGetThingsFilePage, singleThingsFileGetThingsFileStoragePage, singleThingsFileRequestUploadFileCandtu, singleThingsRegisterCandtuThings, singleWorkCreateWork, singleWorkDeleteOne, singleWorkGetOne, singleWorkHandleWork, singleWorkQueryWorkPage, singleWorkUpdateOne, singleZigbeeCreateGroup, singleZigbeeCreateMember, singleZigbeeDeleteZigbeeGroup, singleZigbeeDeleteZigbeeMember, singleZigbeeGetZigbeeGroup, singleZigbeeGetZigbeeGroups, singleZigbeeGetZigbeeMembers, singleZigbeeSendMessageZigbeeGroup, singleZigbeeUpdateZigbeeGroup, tenantBillingCouponSysAddCouponSys, tenantBillingCouponSysDelCouponSys, tenantBillingCouponSysGetCouponsSysList, tenantBillingCouponSysGetOneById, tenantBillingCouponSysUpdateCouponSys, tenantBillingCouponSysUploadCouponImage, tenantBillingCouponTenantDrawCouponSys, tenantBillingCouponTenantGetTenantCouponsSys, tenantBillingCouponTenantGetTenantDrawedCoupons, tenantBillingJobHandlerCheckPackageExpire, tenantBillingJobHandlerNotifyExpirePackageTenant, tenantBillingJobHandlerSyncPackageChangeToKafka, tenantBillingOrderAddOrder, tenantBillingOrderCancelOrder, tenantBillingOrderDownloadOrderByAdmin, tenantBillingOrderGetOrderAmount, tenantBillingOrderListOrder, tenantBillingOrderListOrderByAdmin, tenantBillingOrderPayForOrder, tenantBillingOrderPayback, tenantBillingOrderRefundForOrder, tenantBillingOrderUpdateOrder, tenantBillingOrderUploadOrderReceipt, tenantBillingPackageGetPackage, tenantBillingPackageGetPackageAllList, tenantBillingPackageGetPackageSortList, tenantBillingPackageGetPackageUsageStatistics, tenantBillingPackageGetPackages, tenantBillingPackageItemAddPackageContenItem, tenantBillingPackageItemDelPackageContenItem, tenantBillingPackageItemGetPackageContenItemList, tenantBillingPackageItemGetPackageContenItemList4Tenant, tenantBillingPackageItemUpdatePackageContenItem, tenantBillingPackageUpdatePackageContent, tenantBillingStageDiscountAddStageDiscount, tenantBillingStageDiscountDeleteStageDiscount, tenantBillingStageDiscountListStageDiscount, tenantBillingStageDiscountUpdateStageDiscount, tenantBillingSyncInfoSyncPakcageToKafka, tenantBillingToolsAssessDeploy, tenantBillingToolsAssessTps, tenantBillingToolsRemoveKafkaPackage, tenantTenantAuditTenant, tenantTenantAuthenticationPhoneAuthentication, tenantTenantAuthenticationSuperAuthentication, tenantTenantAuthenticationTenantManagerDispose, tenantTenantAuthenticationUserAuthentication, tenantTenantBatchDeleteTenants, tenantTenantCreateByAdministrator, tenantTenantExportDownloadCsvFile, tenantTenantGetSpecOfAll, tenantTenantGetTenantCustomizationByTenantId, tenantTenantGetTenantSpecByTenantId, tenantTenantGetUsageStatisticsOfAll, tenantTenantGetUserStatisticsOfAll, tenantTenantInternalSendSms, tenantTenantLabelsCreate, tenantTenantLabelsDelete, tenantTenantLabelsGetOne, tenantTenantLabelsLabelsCheck, tenantTenantLabelsQueryList, tenantTenantLabelsQueryListBatch, tenantTenantLabelsUpdate, tenantTenantManagementSyncAllTenantToKafkaChangelog, tenantTenantMenuCheckMenuField, tenantTenantMenuCreateTenantMenu, tenantTenantMenuDeleteTenantMenu, tenantTenantMenuGetTenantMenu, tenantTenantMenuMoveTenantMenu, tenantTenantMenuUpdateTenantMenu, tenantTenantPlatformCreatePlatform, tenantTenantPlatformDeletePlatform, tenantTenantPlatformGetPlatform, tenantTenantPlatformGetPlatformList, tenantTenantPlatformUpdatePlatform, tenantTenantQueryAllTenant, tenantTenantQueryTenantAuditPage, tenantTenantQueryTenantAuditStatistic, tenantTenantQueryTenantDetail, tenantTenantQueryTenantPage, tenantTenantSimPoolCreateSimPool, tenantTenantSimPoolDeleteSimPool, tenantTenantSimPoolQueryConfigInfo, tenantTenantSimPoolQueryPage, tenantTenantSimPoolRefreshAllPool, tenantTenantSimPoolRefreshSimPool, tenantTenantSpecialAuthorityAddTenantToSpecialAuthority, tenantTenantSpecialAuthorityCreateSpecialAuthority, tenantTenantSpecialAuthorityDeleteSpecialAuthority, tenantTenantSpecialAuthorityDeleteTenantFromSpecialAuthority, tenantTenantSpecialAuthorityQuerySpecialAuthorityList, tenantTenantSpecialAuthorityQuerySpecialAuthorityListByTenant, tenantTenantSpecialAuthorityQueryTenantListBySpecialAuthority, tenantTenantSpecialAuthorityUpdateSpecialAuthority, tenantTenantUpdateOneTenantBasic, tenantTenantUpdateTenantCustomization, tenantTenantUpdateTenantSpec, tenantTenantUserAddTenantUser, tenantTenantUserAttrAddTryLoginLog, tenantTenantUserAttrCreate, tenantTenantUserAttrDataMigrationUsingGet, tenantTenantUserAttrDelete, tenantTenantUserAttrGetByPage, tenantTenantUserAttrGetTryLoginLog, tenantTenantUserAttrUpdate, tenantTenantUserAttrUploadFile, tenantTenantUserDelUserConfig, tenantTenantUserDeleteTenantUser, tenantTenantUserDeleteTenantUserBatch, tenantTenantUserFindAllSubUsers, tenantTenantUserFindAllSubUsersWithAuth, tenantTenantUserGetCurrentUser, tenantTenantUserGetCurrentUserCustomization, tenantTenantUserGetIsUserParent, tenantTenantUserGetOneTenantUser, tenantTenantUserGetTenantManagerDetail, tenantTenantUserGetTenantOfCurrentUser, tenantTenantUserGetTenantSpecOfCurrentUser, tenantTenantUserGetUserConfigInfo, tenantTenantUserGetUserLastParent, tenantTenantUserGetUserParents, tenantTenantUserIsManager, tenantTenantUserMessageCreateUserMessage, tenantTenantUserMessageDelete, tenantTenantUserMessageGetByPage, tenantTenantUserMessageGetCurrentUserMessage, tenantTenantUserMessageUpdateMessageStatus, tenantTenantUserMessageUpdateUserMessageStatus, tenantTenantUserQueryTenantUserInfoList, tenantTenantUserQueryTenantUserPage, tenantTenantUserQueryTenantUserPublicProfile, tenantTenantUserQueryTenantUserTree, tenantTenantUserQueryUserInfoList, tenantTenantUserRegisterSubUser, tenantTenantUserRegisterTenantAndUser, tenantTenantUserRegisterValidate, tenantTenantUserRegisterValidateZws, tenantTenantUserResetPasswordByVerificationCode, tenantTenantUserResetTenantUserPassword, tenantTenantUserUpdateCurrentUser, tenantTenantUserUpdateCurrentUserAvatar, tenantTenantUserUpdateCurrentUserEmail, tenantTenantUserUpdateCurrentUserMobile, tenantTenantUserUpdateCurrentUserPassword, tenantTenantUserUpdateCurrentUserSystemSet, tenantTenantUserUpdateOneTenantUser, tenantTenantUserUpdateTenantOfCurrentUser, tenantTenantUserUpdateTenantSpecOfCurrentUser, tenantTenantUserUpdateUserConfigInfo, tenantTenantUserWrittenOffCurrentUser, tenantTenantVerificationCodesQueryVerificationCodeList, tenantTenantVerificationCodesSendVerificationCode, tenantTenantZwsThirdLoginBindUser, tenantTenantZwsThirdLoginBindUserFromUc, tenantTenantZwsThirdLoginCheckAuth, tenantTenantZwsThirdLoginCreateAuth, thingsDigitalTwinThingsBatchUpdate, thingsDigitalTwinThingsQueryList, thingsDigitalTwinThingsQueryOne, thingsDigitalTwinThingsUpdate, thingsInfoModelQueryList, thingsJobHandlerCalThingsUsage, thingsJobHandlerCalThingsUsage10Min, thingsJobHandlerCheckThingsOffline, thingsJobHandlerCleanupThingsMessages, thingsJobHandlerRefreshThingsApn, thingsMessagesBatchPostMessage, thingsMessagesBatchQueryMessageResponse, thingsMessagesBatchQueryRangeMessageResponse, thingsMessagesDigitalTwinSetConfig, thingsMessagesGetBatchMessagePage, thingsMessagesHandleMessageResponse, thingsMessagesPostBatchMessageUnderTenantByThingsSelector, thingsMessagesPostMessageUnderTenantByThingsSelector, thingsMessagesPostStatelessMessage, thingsMessagesQueryDigitalTwinConfigResult, thingsMessagesQueryList, thingsMessagesQueryMessageResponse, thingsMessagesSendMessage, thingsStandByMessagesCreateStandByMessage, thingsStandByMessagesPostStandByMessage, thingsStatisticsGetThingsModelThings, thingsStatisticsGetThingsNormalFault, thingsStatisticsGetThingsOnlineOffline, thingsThingsBatchBindThings, thingsThingsBatchQueryChildrenThings, thingsThingsBatchRegisterThings, thingsThingsBatchUnBindThings, thingsThingsBatchUpdateConfiguration, thingsThingsBatchUpdateThings, thingsThingsBindThings, thingsThingsCheckCreateThingsEnable, thingsThingsCheckThings, thingsThingsCleanAllThingsByTenant, thingsThingsClearBindThings, thingsThingsDelete, thingsThingsDownloadThingsFile, thingsThingsDownloadThingsFileByTenant, thingsThingsForceThingsOffline, thingsThingsForceThingsOfflineForThirdThingsId, thingsThingsGetBatchImportThingsProgress, thingsThingsGetCurrentImportTask, thingsThingsGetSingleIndexList, thingsThingsGetThingsNumber, thingsThingsGetThingsNumberForInternal, thingsThingsGetThingsOfInfomodel, thingsThingsGetThingsStatisticInfo, thingsThingsInternalQueryList, thingsThingsLabelCreate, thingsThingsLabelDelete, thingsThingsLabelDeleteAllLabelsByThingsId, thingsThingsLabelQueryList, thingsThingsLabelQueryThingsLabels, thingsThingsLabelQueryValueListByLabel, thingsThingsMaintenanceGetSyncChildrenProgress, thingsThingsMaintenanceQueryList, thingsThingsMaintenanceQueryListFromMqtt, thingsThingsMaintenanceQueryLogoutHistoryList, thingsThingsMaintenanceQueryLogoutThingsList, thingsThingsMaintenanceQuerySyncTHingsSelectorInfo, thingsThingsMaintenanceSyncChildren, thingsThingsMaintenanceSyncThingsChannel, thingsThingsMaintenanceSyncThingsIndexName, thingsThingsMaintenanceSyncThingsInfo, thingsThingsMaintenanceSyncThingsSelectorInfo, thingsThingsMqttGenerateThingsLoginByTenantTokensV, thingsThingsMqttGenerateThingsNativeTokens, thingsThingsMqttGenerateThingsTokens, thingsThingsMqttGetThingsNativeTokens, thingsThingsMqttV2GenerateThingsLoginByTenantTokensV, thingsThingsMqttV2GenerateThingsTokensV, thingsThingsQueryAllList, thingsThingsQueryChildrenThings, thingsThingsQueryChildrenThingsInfoModels, thingsThingsQueryGwThings, thingsThingsQueryList, thingsThingsQueryOne, thingsThingsQueryParentThings, thingsThingsRegisterThings, thingsThingsThingsInfoByThirdThingsIds, thingsThingsThingsInfoWithoutTenant, thingsThingsUnbindThings, thingsThingsUpdate, thingsThingsUpdateConnectionStatus, thingsThingsUpdateImportThingsProgressStatus, thingsThingsUpdateIndexName, thingsThingsUpdateThingsApn, thingsThingsUpdateThingsUsage, thingsThingsUpdateThingsUsageList, thingsThingsV2GetThingsList, thingsThingsVerificationCreate, thingsThingsVerificationDeleteOne, thingsThingsVerificationGetOne, thingsThingsVerificationPageQuery, thingsThingsVerificationUpdate, thingsThingsVerificationUpdateStatus, thingsUsageStatisticsGetUsageStatisticsOfAll, thingsUserResourceAddThingsListByUser, thingsUserResourceDeleteThingsListUnderUser, thingsUserResourceDeleteThingsMapUnderUser, thingsUserResourceGetSubUserPageByThings, thingsUserResourceGetThingListUnderUser, thingsUserResourceGetUserListUnderThings, thingsUserResourceUpdateThingListUnderUser };
